const generalKnowledge = [
  // ── VEHICLE INSPECTION ─────────────────────────────────────────────────────
  {
    id: "gk001",
    question: "What is the minimum tread depth required for front tires on a commercial motor vehicle?",
    options: ["2/32 inch", "4/32 inch", "6/32 inch", "8/32 inch"],
    answer: 1,
    explanation: "Front tires require at least 4/32 inch tread depth. All other tires (drive axle and trailer) require at least 2/32 inch.",
  },
  {
    id: "gk002",
    question: "What is the minimum tread depth for all tires OTHER than front tires on a CMV?",
    options: ["1/32 inch", "2/32 inch", "4/32 inch", "6/32 inch"],
    answer: 1,
    explanation: "Drive axle and trailer tires must have at least 2/32 inch tread depth. Front tires require 4/32 inch.",
  },
  {
    id: "gk003",
    question: "During a pre-trip inspection, you find a small oil leak under the engine. What should you do?",
    options: ["Add oil and drive carefully", "Drive to the nearest repair shop", "Do not drive the vehicle until it is repaired", "Wipe it off and recheck later"],
    answer: 2,
    explanation: "Any fluid leak is a defect that makes the vehicle unsafe. You must not drive until the leak is repaired.",
  },
  {
    id: "gk004",
    question: "A pre-trip inspection must be performed:",
    options: ["Once a week", "Once a month", "Before every trip", "Every 10,000 miles"],
    answer: 2,
    explanation: "Federal regulations require drivers to inspect their vehicle before every trip to ensure it is safe to operate.",
  },
  {
    id: "gk005",
    question: "Which of the following is NOT checked during the engine compartment inspection?",
    options: ["Engine oil level", "Coolant level", "Power steering fluid", "Passenger seat adjustment"],
    answer: 3,
    explanation: "Passenger seat adjustment is an interior/cab check. Engine compartment checks cover fluids, hoses, belts, and electrical connections.",
  },
  {
    id: "gk006",
    question: "A bulge or cut in a tire sidewall means:",
    options: ["The tire is safe if it holds air pressure", "Normal wear for a commercial tire", "A defect requiring the tire be taken out of service", "Only a cosmetic blemish"],
    answer: 2,
    explanation: "Bulges, cuts, or exposed cords are serious defects. The vehicle must not be driven with such a tire.",
  },
  {
    id: "gk007",
    question: "How soon after beginning a trip must you check cargo securement?",
    options: ["Within the first 25 miles", "Within the first 50 miles", "Within the first 100 miles", "At the first scheduled stop"],
    answer: 1,
    explanation: "Federal rules require drivers to inspect cargo within the first 50 miles, then every 3 hours or 150 miles thereafter.",
  },
  {
    id: "gk008",
    question: "During a walk-around inspection, which lights must you check?",
    options: ["Headlights only", "Taillights only", "All exterior lights and reflectors", "Turn signals only"],
    answer: 2,
    explanation: "All exterior lights — headlights, taillights, brake lights, turn signals, clearance lights, and reflectors — must be checked.",
  },
  {
    id: "gk009",
    question: "What does it mean when the low air pressure warning light comes on while driving?",
    options: ["Normal operation during braking", "Air pressure has dropped below 60 psi — stop and investigate", "The compressor is working overtime", "You should brake harder"],
    answer: 1,
    explanation: "The warning light activates when air pressure falls below about 60 psi (varies by system). Stop safely and investigate before continuing.",
  },
  {
    id: "gk010",
    question: "Which of the following is a sign of a bad front wheel bearing during inspection?",
    options: ["Excessive play in the steering wheel", "Rust streaks from lug nuts", "Mismatched tire sizes on the steer axle", "Oil seeping from the hub seal"],
    answer: 3,
    explanation: "Oil leaking from a hub seal onto the brake components or around the wheel indicates a bad bearing or seal that must be repaired.",
  },
  {
    id: "gk011",
    question: "When checking brakes during a pre-trip inspection, you should look for:",
    options: ["Only the brake pedal height", "Cracked drums, missing or broken parts, and worn linings", "Only ABS light operation", "Just the parking brake function"],
    answer: 1,
    explanation: "Brake inspection includes checking for cracked drums, worn linings, broken components, and proper adjustment.",
  },
  {
    id: "gk012",
    question: "What should you check on the fifth wheel during a pre-trip inspection?",
    options: ["That the jaws are open", "That it is properly lubricated and the jaws are locked around the kingpin", "Only that it is level", "That it is not welded to the trailer"],
    answer: 1,
    explanation: "The fifth wheel should be lubricated and the locking jaws should be fully closed around the kingpin with no gap.",
  },
  {
    id: "gk013",
    question: "Lug nuts should be checked for:",
    options: ["Rust and missing nuts only", "Rust streaks, missing nuts, and evidence of looseness", "Color uniformity", "Proper coating only"],
    answer: 1,
    explanation: "Inspect lug nuts for rust streaks (sign of looseness), missing nuts, and cracks in the wheel that could indicate a wheel problem.",
  },
  {
    id: "gk014",
    question: "During an engine start check, the oil pressure gauge should reach normal range within:",
    options: ["30 seconds", "1 minute", "A few seconds after starting", "5 minutes"],
    answer: 2,
    explanation: "Oil pressure should build and reach normal range within a few seconds of starting. If not, shut off the engine and investigate.",
  },
  {
    id: "gk015",
    question: "The emergency equipment you are required to carry includes:",
    options: ["Fire extinguisher, 3 reflective triangles, and spare electrical fuses", "Only reflective triangles", "Only a fire extinguisher", "Flares and a tow rope"],
    answer: 0,
    explanation: "Federal law requires a fire extinguisher, 3 bi-directional emergency reflective triangles, and spare electrical fuses (unless circuit breakers are used).",
  },
  // ── BASIC VEHICLE CONTROL ────────────────────────────────────────────────────
  {
    id: "gk016",
    question: "What is the proper way to hold a steering wheel?",
    options: ["One hand at the top", "Both hands at the bottom", "Both hands on opposite sides (9 and 3 or 10 and 2)", "One hand at 12 o'clock"],
    answer: 2,
    explanation: "Hold the steering wheel firmly with both hands on opposite sides. This gives best control for turning and prevents losing control.",
  },
  {
    id: "gk017",
    question: "When backing a straight vehicle, you should:",
    options: ["Use only mirrors", "Use a helper and back as slowly as possible, using mirrors", "Back quickly to limit exposure time", "Only back in a straight line without turning"],
    answer: 1,
    explanation: "Always use a helper (spotter) when possible, and back slowly to maintain control. Use mirrors throughout the maneuver.",
  },
  {
    id: "gk018",
    question: "Why is it difficult to judge the speed and distance of a large truck?",
    options: ["Because trucks have larger mirrors", "Because trucks are so large that they appear to move slower than they actually are", "Because trucks have wider turning radii", "Because trucks are painted with reflective paint"],
    answer: 1,
    explanation: "The large size of CMVs creates an optical illusion that makes them appear to move slower than they actually are.",
  },
  {
    id: "gk019",
    question: "When making a right turn with a long vehicle, you should:",
    options: ["Stay as far right as possible throughout the turn", "Swing wide to the left to allow the rear wheels to clear the curb", "Turn sharply to complete the turn quickly", "Use the left lane for right turns"],
    answer: 1,
    explanation: "Off-tracking (rear wheels cutting corners) requires swinging wide to allow the rear wheels to clear the curb on a right turn.",
  },
  {
    id: "gk020",
    question: "What is 'off-tracking'?",
    options: ["When brakes lock up during a stop", "The tendency of the rear wheels to follow a different path than the front wheels", "When a vehicle slides sideways", "When cargo shifts during a turn"],
    answer: 1,
    explanation: "Off-tracking is when the rear wheels of a long vehicle do not follow the same path as the front wheels, especially during turns.",
  },
  // ── SHIFTING AND TRANSMISSION ────────────────────────────────────────────────
  {
    id: "gk021",
    question: "When is it acceptable to skip gears when downshifting?",
    options: ["Never — always downshift one gear at a time", "When the engine is cold", "When traffic is light", "When going downhill and you need to slow down quickly"],
    answer: 0,
    explanation: "Always downshift one gear at a time. Skipping gears can cause loss of control or engine damage.",
  },
  {
    id: "gk022",
    question: "When driving a vehicle with a manual transmission, you should downshift BEFORE:",
    options: ["Crossing railroad tracks", "Starting down a long steep grade", "Approaching a stop sign", "Accelerating on the highway"],
    answer: 1,
    explanation: "Downshift before starting downhill, not while on it. Using lower gears on downgrades keeps engine braking effective and prevents brake fade.",
  },
  {
    id: "gk023",
    question: "Engine braking is most effective when the engine is:",
    options: ["In the highest gear", "In the lowest gear appropriate for the speed", "In neutral", "With the clutch depressed"],
    answer: 1,
    explanation: "Engine braking is most effective when you use the lowest gear appropriate for your current speed, allowing maximum retardation.",
  },
  // ── SEEING AND COMMUNICATING ─────────────────────────────────────────────────
  {
    id: "gk024",
    question: "You should look ahead of your vehicle to identify hazards early. For highway speeds, this means looking:",
    options: ["1/4 mile ahead", "1/8 mile ahead", "50 feet ahead", "Just past the hood of your truck"],
    answer: 0,
    explanation: "At highway speeds, look at least 12–15 seconds ahead — approximately 1/4 mile. This gives time to identify and react to hazards before they become emergencies.",
  },
  {
    id: "gk025",
    question: "How often should you check your mirrors while driving?",
    options: ["Only when changing lanes", "Every 5–8 seconds", "Every 30 seconds", "Only when you hear a noise"],
    answer: 1,
    explanation: "Check your mirrors every 5–8 seconds to maintain a complete picture of what is around your vehicle.",
  },
  {
    id: "gk026",
    question: "When should you use your horn?",
    options: ["To signal frustration at other drivers", "When it may help avoid a collision", "Only in residential areas", "Never — it is prohibited on CMVs"],
    answer: 1,
    explanation: "Use your horn when it may help warn others and prevent a collision. Avoid using it for non-safety reasons.",
  },
  {
    id: "gk027",
    question: "Which of the following is NOT in a CMV's blind spot?",
    options: ["Directly behind the trailer", "Just ahead of the cab", "Directly in front of the driver", "The left side close to the cab door"],
    answer: 3,
    explanation: "Blind spots (no-zones) include directly in front, directly behind, and along the sides. The driver's side close to the door is usually visible.",
  },
  {
    id: "gk028",
    question: "When you need to communicate danger to following drivers, you should:",
    options: ["Flash your headlights", "Turn on your 4-way flashers", "Honk your horn continuously", "Brake suddenly"],
    answer: 1,
    explanation: "Use your four-way hazard lights to warn following drivers of danger or when moving slowly.",
  },
  // ── SPEED MANAGEMENT ──────────────────────────────────────────────────────────
  {
    id: "gk029",
    question: "Total stopping distance consists of:",
    options: ["Perception distance + reaction distance only", "Perception distance + reaction distance + braking distance", "Braking distance only", "Reaction distance + braking distance only"],
    answer: 1,
    explanation: "Total stopping distance = perception distance (seeing hazard) + reaction distance (foot moving to brake) + braking distance (vehicle stopping).",
  },
  {
    id: "gk030",
    question: "At 55 mph, total stopping distance for a fully loaded CMV is approximately:",
    options: ["100 feet", "200 feet", "300 feet", "Over 400 feet"],
    answer: 3,
    explanation: "At 55 mph a fully loaded CMV may need over 400 feet to stop — much more than a car. Perception + reaction + braking all add up.",
  },
  {
    id: "gk031",
    question: "Driving too fast for conditions is a leading cause of accidents because:",
    options: ["It causes tire wear", "It reduces stopping distance", "It increases stopping distance beyond the driver's sight distance", "It improves fuel economy"],
    answer: 2,
    explanation: "Excessive speed extends stopping distance. If you cannot stop within the distance you can see ahead, you are driving too fast for conditions.",
  },
  {
    id: "gk032",
    question: "What effect does a heavy load have on stopping distance?",
    options: ["It decreases stopping distance", "It has no effect if you brake early", "It significantly increases stopping distance", "It only affects stopping on wet roads"],
    answer: 2,
    explanation: "A fully loaded truck takes significantly longer to stop than an empty one. The heavier the load, the greater the braking distance needed.",
  },
  {
    id: "gk033",
    question: "Speed should be adjusted when:",
    options: ["Only during rain", "Only in school zones", "Whenever conditions such as weather, visibility, traffic, or road type affect safety", "Only when posted limits change"],
    answer: 2,
    explanation: "You must reduce speed whenever conditions — rain, fog, traffic, grades, curves, road type — require it for safe operation.",
  },
  // ── SPACE MANAGEMENT ──────────────────────────────────────────────────────────
  {
    id: "gk034",
    question: "The recommended following distance for a CMV at speeds over 40 mph is:",
    options: ["1 second per 10 feet of vehicle length", "2 seconds for any speed", "At least 4 seconds", "At least 7 seconds"],
    answer: 0,
    explanation: "At speeds over 40 mph, allow 1 second per 10 feet of vehicle length plus 1 additional second. A 60-foot truck needs at least 7 seconds.",
  },
  {
    id: "gk035",
    question: "Under what conditions should you increase your following distance?",
    options: ["Only in rain", "In rain, low visibility, heavy traffic, when following motorcycles, or when carrying hazmat", "Only when your vehicle is loaded", "Never — the standard following distance is always sufficient"],
    answer: 1,
    explanation: "Increase following distance in adverse conditions, with hazmat, when following motorcycles, or whenever extra space is needed for safety.",
  },
  {
    id: "gk036",
    question: "Why do large trucks need more space ahead than cars?",
    options: ["Because of wider turning radii", "Because they take much longer to stop", "Because they have larger engines", "Because drivers sit higher"],
    answer: 1,
    explanation: "CMVs are heavier and take much longer to stop. More space ahead is needed to allow adequate stopping distance.",
  },
  {
    id: "gk037",
    question: "When being tailgated, you should:",
    options: ["Speed up to create more space", "Brake-check the tailgater", "Increase your following distance and avoid sudden stops", "Change lanes immediately"],
    answer: 2,
    explanation: "When tailgated, increase your following distance to give yourself room to stop gradually, reducing the risk of the tailgater rear-ending you.",
  },
  // ── NIGHT AND ADVERSE DRIVING ────────────────────────────────────────────────
  {
    id: "gk038",
    question: "When driving at night, you should reduce speed because:",
    options: ["Headlights are less effective than daylight", "You cannot stop within your headlight sight distance at normal highway speeds unless you slow down", "Night traffic is heavier", "Tires are less effective at night"],
    answer: 1,
    explanation: "At highway speeds, your stopping distance may exceed your headlight range. Reducing speed ensures you can stop within the distance you can see.",
  },
  {
    id: "gk039",
    question: "When should you use high beam headlights?",
    options: ["Always on highways", "When you cannot see at least 500 feet ahead with low beams, and no oncoming traffic is present", "Only in fog", "Never on a CMV"],
    answer: 1,
    explanation: "Use high beams when you need more light and no oncoming traffic or vehicles ahead would be blinded.",
  },
  {
    id: "gk040",
    question: "In fog, you should use:",
    options: ["High beams for maximum visibility", "Low beams because high beams reflect off the fog and reduce visibility", "No headlights — use hazard lights only", "Parking lights only"],
    answer: 1,
    explanation: "High beams reflect off fog, creating glare and reducing visibility. Low beams aim downward and provide better visibility in fog.",
  },
  {
    id: "gk041",
    question: "What causes 'highway hypnosis'?",
    options: ["Eating while driving", "Monotonous roadway conditions causing drowsiness or loss of focus", "Bright sunlight reflecting off the road", "Following too close"],
    answer: 1,
    explanation: "Highway hypnosis is a trance-like state caused by the monotony of long-distance driving, leading to reduced alertness and slower reaction.",
  },
  {
    id: "gk042",
    question: "When driving in rain, you should:",
    options: ["Drive at the posted speed limit regardless", "Reduce speed, increase following distance, and watch for hydroplaning", "Only use windshield wipers but maintain speed", "Stay in the left lane"],
    answer: 1,
    explanation: "Rain reduces traction and visibility. Slow down, increase following distance, and be alert for hydroplaning.",
  },
  {
    id: "gk043",
    question: "Hydroplaning occurs when:",
    options: ["Brakes lock up on dry pavement", "Water builds up under tires, causing them to lose contact with the road", "The engine overheats", "Tires rotate too fast on wet roads"],
    answer: 1,
    explanation: "Hydroplaning happens when water pressure under tires lifts them off the road surface. If you feel it, ease off the accelerator gently.",
  },
  {
    id: "gk044",
    question: "If your vehicle starts to hydroplane, you should:",
    options: ["Apply brakes firmly", "Accelerate to maintain traction", "Release the accelerator gently and avoid braking or sharp steering", "Downshift immediately"],
    answer: 2,
    explanation: "Gently ease off the accelerator. Avoid braking or sharp steering until tires regain contact with the road.",
  },
  {
    id: "gk045",
    question: "Black ice is dangerous because:",
    options: ["It is very thick", "It forms only on bridges", "It is difficult to see and provides very little traction", "It causes tire damage"],
    answer: 2,
    explanation: "Black ice is thin, transparent ice that blends with the road surface. It is nearly invisible and extremely slippery.",
  },
  {
    id: "gk046",
    question: "Where is ice most likely to form first?",
    options: ["On expressways", "On straight, flat sections of road", "On bridges, overpasses, and shaded areas", "On gravel roads"],
    answer: 2,
    explanation: "Bridges and overpasses lose heat from both top and bottom, freezing before other road surfaces. Shaded areas also freeze first.",
  },
  {
    id: "gk047",
    question: "When driving in strong crosswinds, you should:",
    options: ["Drive faster to reduce the effect", "Grip the steering wheel firmly and reduce speed", "Use cruise control", "Move to the left lane"],
    answer: 1,
    explanation: "Crosswinds can push large vehicles off course. Grip the wheel firmly, reduce speed, and be especially alert when passing gaps in sheltered areas.",
  },
  // ── SKID CONTROL ─────────────────────────────────────────────────────────────
  {
    id: "gk048",
    question: "What is the most common cause of a vehicle skid?",
    options: ["Under-inflated tires", "Driving too fast for conditions", "Old brakes", "A loaded trailer"],
    answer: 1,
    explanation: "Most skids are caused by driving too fast for road conditions, which results in loss of traction.",
  },
  {
    id: "gk049",
    question: "During a front-wheel skid, the vehicle will:",
    options: ["Spin in a circle", "Continue straight regardless of steering input", "Pull sharply to one side", "Stop immediately"],
    answer: 1,
    explanation: "In a front-wheel skid, the front wheels lose traction and the vehicle continues straight even if you turn the wheel.",
  },
  {
    id: "gk050",
    question: "To correct a rear-wheel skid (drive wheels), you should:",
    options: ["Apply the brakes firmly", "Steer in the direction the rear is skidding", "Steer in the opposite direction of the skid", "Accelerate to pull the rear back"],
    answer: 1,
    explanation: "Counter-steer into the direction the rear is skidding. Once corrected, quickly straighten the wheel to avoid skidding the other way.",
  },
  {
    id: "gk051",
    question: "Brake fade is caused by:",
    options: ["Cold brakes on icy roads", "Overheating of brakes from excessive use, reducing their effectiveness", "ABS activation during braking", "Wet brakes"],
    answer: 1,
    explanation: "Prolonged heavy braking overheats brake components, reducing their friction ability — this is brake fade. It is especially common on long downgrades.",
  },
  // ── EMERGENCIES ───────────────────────────────────────────────────────────────
  {
    id: "gk052",
    question: "If a tire blows out while you are driving, you should:",
    options: ["Brake hard immediately", "Steer off the road quickly", "Grip the steering wheel firmly, steer straight, and gradually slow by releasing the accelerator", "Accelerate to maintain traction"],
    answer: 2,
    explanation: "A blowout can jerk the steering wheel. Grip firmly, steer straight, and gradually ease off the accelerator. Brake gently only after you have control.",
  },
  {
    id: "gk053",
    question: "If your brakes fail on a downgrade, you should:",
    options: ["Pump the brakes rapidly", "Downshift and look for a runaway truck ramp or escape ramp", "Pull the parking brake immediately", "Turn off the engine"],
    answer: 1,
    explanation: "Use the engine brake and transmission to slow, and head for a runaway truck ramp if available. Ramps use gravel or steep incline to stop the vehicle.",
  },
  {
    id: "gk054",
    question: "If you have a front brake failure, your vehicle will:",
    options: ["Stop straight", "Veer to one side", "Have longer stopping distance but still steer normally", "Spin out"],
    answer: 2,
    explanation: "With front brake failure you still have rear brakes. Stopping distance increases significantly, but you can still steer.",
  },
  {
    id: "gk055",
    question: "If your accelerator sticks while driving, you should:",
    options: ["Turn off the ignition immediately", "Shift to neutral, safely stop the vehicle, and turn off the engine", "Apply full brakes", "Continue driving — it will unstick"],
    answer: 1,
    explanation: "Shift to neutral to break the engine-wheel connection, stop safely, then turn off the engine.",
  },
  {
    id: "gk056",
    question: "If you must stop on the side of the road, you should place warning devices at:",
    options: ["10, 50, and 100 feet behind the vehicle", "100, 200, and 300 feet behind the vehicle", "Within 10 minutes of stopping: within 10 feet at the traffic side, at 100 feet and 200 feet to the rear", "Only at the front and rear of the vehicle"],
    answer: 2,
    explanation: "FMCSA requires warning devices placed within 10 feet of the front or rear at the traffic side, at 100 feet and 200 feet to the rear (or adjusted for curves/hills).",
  },
  {
    id: "gk057",
    question: "How soon must warning devices be placed if you must stop on a roadway?",
    options: ["Within 30 minutes", "Within 10 minutes", "Within 1 minute", "Before you stop the engine"],
    answer: 1,
    explanation: "You must place warning devices (triangles, flares, etc.) within 10 minutes of stopping on a roadway.",
  },
  {
    id: "gk058",
    question: "When should you use your parking brake to stop the vehicle in an emergency?",
    options: ["Never — always use the service brakes", "When your service brakes have completely failed", "In all emergencies", "Only on level roads"],
    answer: 1,
    explanation: "The parking brake is for parking, not emergency stops. However, if service brakes completely fail, use it carefully to avoid jackknifing.",
  },
  // ── HOURS OF SERVICE ──────────────────────────────────────────────────────────
  {
    id: "gk059",
    question: "Under the 11-hour driving limit, a property-carrying driver may drive a maximum of:",
    options: ["8 hours", "10 hours", "11 hours after 10 consecutive hours off duty", "14 hours after 10 consecutive hours off duty"],
    answer: 2,
    explanation: "Property-carrying drivers may drive up to 11 hours after taking 10 or more consecutive hours off duty.",
  },
  {
    id: "gk060",
    question: "The 14-hour rule states that a property-carrying driver may NOT drive:",
    options: ["More than 14 hours in any 24-hour period", "After the 14th hour following the start of the on-duty period after 10 consecutive hours off", "More than 14 hours of on-duty time", "After 14 hours of driving"],
    answer: 1,
    explanation: "The 14-hour window starts when you begin any on-duty time. You cannot drive after the 14th consecutive hour from that point, regardless of off-duty time within that window.",
  },
  {
    id: "gk061",
    question: "Under the 60/70-hour rule, a driver using a 7-day schedule may not drive after accumulating:",
    options: ["60 hours of on-duty time in 7 consecutive days", "70 hours in 8 consecutive days", "60 hours of driving in 7 days", "Either 60 hours in 7 days or 70 hours in 8 days depending on employer's operating schedule"],
    answer: 3,
    explanation: "Carriers operating 7 days a week use the 70-hour/8-day limit. Those not operating all 7 days use the 60-hour/7-day limit. Drivers use whichever applies.",
  },
  {
    id: "gk062",
    question: "A 30-minute rest break is required after how many hours of driving?",
    options: ["After 6 hours", "After 8 hours", "After 10 hours", "After 11 hours"],
    answer: 1,
    explanation: "Property-carrying drivers must take a 30-minute break after 8 cumulative hours of driving since the last off-duty or sleeper-berth period.",
  },
  {
    id: "gk063",
    question: "What is the minimum off-duty time required before a driver may resume driving under the 11-hour rule?",
    options: ["6 consecutive hours", "8 consecutive hours", "10 consecutive hours", "12 consecutive hours"],
    answer: 2,
    explanation: "Drivers must have 10 consecutive hours off duty before driving under the 11-hour rule.",
  },
  {
    id: "gk064",
    question: "What records must a driver keep regarding Hours of Service?",
    options: ["Only receipts for fuel", "A Record of Duty Status (RODS) / logbook, or electronic logging device (ELD) records", "Only a daily mileage log", "Only the carrier's dispatch records"],
    answer: 1,
    explanation: "Drivers must maintain a Record of Duty Status — either paper logs or ELD records — for the current day and the previous 7 days.",
  },
  // ── CDL CLASSES AND ENDORSEMENTS ─────────────────────────────────────────────
  {
    id: "gk065",
    question: "A Class A CDL is required to operate:",
    options: ["Any vehicle with air brakes", "Any combination of vehicles with a GCWR of 26,001 pounds or more when the towed vehicle is over 10,000 pounds", "Any vehicle over 10,000 pounds", "Buses only"],
    answer: 1,
    explanation: "Class A covers any combination vehicle with GCWR of 26,001+ lbs where the towed unit exceeds 10,000 lbs GVWR.",
  },
  {
    id: "gk066",
    question: "A Class B CDL is required to operate:",
    options: ["Any combination vehicle over 26,000 pounds", "Any single vehicle with GVWR over 26,000 pounds, or towing a vehicle not over 10,000 pounds GVWR", "Tractor-trailers only", "Vehicles carrying 16 or more passengers"],
    answer: 1,
    explanation: "Class B covers a single vehicle over 26,000 lbs GVWR (or towing up to 10,000 lbs). A Class B holder can also drive Class C vehicles.",
  },
  {
    id: "gk067",
    question: "The 'P' endorsement on a CDL authorizes the driver to operate:",
    options: ["Vehicles carrying hazardous materials", "Vehicles with air brakes", "Passenger vehicles (buses) carrying 16 or more passengers including the driver", "Tank vehicles"],
    answer: 2,
    explanation: "The P (Passenger) endorsement is required to drive a bus or passenger-carrying vehicle with 16 or more total occupants (including driver).",
  },
  {
    id: "gk068",
    question: "Which endorsement is required to haul hazardous materials in quantities requiring placards?",
    options: ["X endorsement", "N endorsement", "H endorsement", "T endorsement"],
    answer: 2,
    explanation: "The H (Hazardous Materials) endorsement is required when transporting hazardous materials in amounts requiring placards.",
  },
  {
    id: "gk069",
    question: "What does the 'N' endorsement authorize?",
    options: ["Double and triple trailers", "Tank vehicles", "Passenger vehicles", "School buses"],
    answer: 1,
    explanation: "The N (Tank Vehicle) endorsement authorizes operation of tank vehicles.",
  },
  {
    id: "gk070",
    question: "What does the 'T' endorsement authorize?",
    options: ["Tank vehicles", "Passenger buses", "Double and triple trailers", "Hazardous materials"],
    answer: 2,
    explanation: "The T endorsement authorizes operation of double and triple trailers.",
  },
  {
    id: "gk071",
    question: "What does the 'S' endorsement authorize?",
    options: ["Semi-trucks", "School buses", "Specialty vehicles", "Single-axle vehicles"],
    answer: 1,
    explanation: "The S endorsement is required to drive a school bus.",
  },
  {
    id: "gk072",
    question: "To obtain a CDL, a driver must first obtain a:",
    options: ["Commercial Driver's License permit after taking a skills test", "Commercial Learner's Permit (CLP) by passing the required knowledge tests", "Regular driver's license upgrade", "Medical certificate only"],
    answer: 1,
    explanation: "A driver must first pass the required written knowledge tests to get a CLP, then practice and pass a skills test to get the CDL.",
  },
  // ── HAZARDOUS MATERIALS ───────────────────────────────────────────────────────
  {
    id: "gk073",
    question: "Hazardous materials must be placarded on the vehicle when:",
    options: ["Any amount is transported", "The quantity meets or exceeds the threshold for placarding as defined in HM regulations", "Only for radioactive materials", "For all loads over 10,000 lbs"],
    answer: 1,
    explanation: "Placards are required based on the type and quantity of hazmat. Some materials require placards for any amount; others only above specific thresholds.",
  },
  {
    id: "gk074",
    question: "When transporting hazardous materials, a driver must have:",
    options: ["A fire extinguisher and extra placards only", "Shipping papers, placards, labels, and emergency response information readily accessible", "Only the shipping papers", "Only the emergency response guidebook"],
    answer: 1,
    explanation: "Hazmat shipments require proper shipping papers within driver's reach, correct labels on packages, vehicle placards, and emergency response information.",
  },
  {
    id: "gk075",
    question: "Where should shipping papers (for hazmat) be kept while driving?",
    options: ["In the glove compartment", "In a pouch on the driver's door or visible in the driver's reach on the seat when not driving", "On the dashboard", "In the cargo area with the freight"],
    answer: 1,
    explanation: "Hazmat shipping papers must be within the driver's reach while driving (driver's door pouch or seat) and on the seat or visible from outside when not in the vehicle.",
  },
  {
    id: "gk076",
    question: "What does the Emergency Response Guidebook (ERG) tell you?",
    options: ["How to load hazmat cargo", "Routing restrictions for hazmat", "Initial response information for hazmat incidents, including first aid and safety distance", "Hours of service exemptions for hazmat drivers"],
    answer: 2,
    explanation: "The ERG gives first responders and drivers initial safety information, isolation distances, and first aid for hazmat incidents.",
  },
  {
    id: "gk077",
    question: "What is a 'hazmat' placard?",
    options: ["A label placed on individual packages", "A diamond-shaped sign placed on the vehicle to warn others of hazardous cargo", "A permit to transport hazardous materials", "The hazmat shipping paper"],
    answer: 1,
    explanation: "Placards are diamond-shaped signs at least 10 inches on each side, placed on the outside of the vehicle to warn of hazardous cargo.",
  },
  {
    id: "gk078",
    question: "A '1' in the lower corner of a placard means:",
    options: ["Class 1 flammables only", "The material is in a Division 1 explosive category", "The vehicle carries only one type of hazmat", "Packing group I (high danger)"],
    answer: 1,
    explanation: "Placards showing '1' in the lower corner indicate Class 1 explosives.",
  },
  {
    id: "gk079",
    question: "If you are involved in a hazmat accident, you should:",
    options: ["Move the vehicle to a safe location before calling for help", "Keep bystanders away, notify authorities, and not move the vehicle unless necessary for safety", "Try to clean up the spill yourself", "Ignore it if it's a small spill"],
    answer: 1,
    explanation: "Keep people away from the area, call 911 and your dispatcher, and do not move the vehicle unless necessary for safety.",
  },
  // ── WEIGHT AND BRIDGE LAWS ────────────────────────────────────────────────────
  {
    id: "gk080",
    question: "What is the maximum gross vehicle weight allowed on Interstate highways without special permits?",
    options: ["72,000 lbs", "80,000 lbs", "88,000 lbs", "100,000 lbs"],
    answer: 1,
    explanation: "The federal limit is 80,000 lbs gross vehicle weight on Interstate highways. State permits may allow more on certain routes.",
  },
  {
    id: "gk081",
    question: "What is the maximum single axle weight limit under federal law?",
    options: ["17,000 lbs", "20,000 lbs", "22,400 lbs", "25,000 lbs"],
    answer: 1,
    explanation: "The federal limit for a single axle is 20,000 lbs.",
  },
  {
    id: "gk082",
    question: "What is the maximum tandem axle weight limit under federal law?",
    options: ["30,000 lbs", "34,000 lbs", "36,000 lbs", "40,000 lbs"],
    answer: 1,
    explanation: "A tandem axle (two axles spaced between 40 and 96 inches apart) is limited to 34,000 lbs under federal law.",
  },
  {
    id: "gk083",
    question: "The bridge law (Bridge Formula B) limits weight to protect:",
    options: ["Driver safety only", "Bridges and roads from damage caused by concentrated axle weight", "Fuel efficiency", "Cargo from damage"],
    answer: 1,
    explanation: "The bridge formula limits the weight per axle group based on axle spacing to prevent structural damage to bridges and roads.",
  },
  {
    id: "gk084",
    question: "Where must weight limits be posted on a bridge?",
    options: ["Only on state highways", "At state borders", "On or near the bridge", "In the trucker's atlas"],
    answer: 2,
    explanation: "Weight limit signs must be posted on or near bridges that cannot safely carry the maximum legal load.",
  },
  // ── CARGO SECUREMENT ──────────────────────────────────────────────────────────
  {
    id: "gk085",
    question: "Who is responsible for ensuring cargo is properly secured?",
    options: ["Only the shipper", "Only the carrier", "Both the driver and the carrier share responsibility; the driver must inspect and may refuse unsafe loads", "The consignee"],
    answer: 2,
    explanation: "Drivers must inspect cargo before driving and throughout the trip. They may refuse loads that cannot be safely secured.",
  },
  {
    id: "gk086",
    question: "When should you re-inspect cargo securement during a long trip?",
    options: ["Only at the destination", "Within first 50 miles, then every 3 hours or 150 miles, whichever comes first", "Only when you stop for fuel", "Every hour"],
    answer: 1,
    explanation: "Check within the first 50 miles, then every 3 hours or 150 miles, and after any change in cargo.",
  },
  {
    id: "gk087",
    question: "Cargo that is improperly loaded can:",
    options: ["Only damage the cargo", "Make the vehicle harder to handle, change braking, and cause rollovers", "Only affect fuel economy", "Have no effect if the vehicle is slow enough"],
    answer: 1,
    explanation: "Improperly secured or loaded cargo affects vehicle handling, center of gravity, braking distances, and can cause rollovers.",
  },
  {
    id: "gk088",
    question: "What is the minimum number of tie-downs required for cargo up to 5 feet long?",
    options: ["1", "2", "3", "4"],
    answer: 1,
    explanation: "At least 2 tie-downs are required for cargo up to 5 feet long weighing 1,100 lbs or more.",
  },
  {
    id: "gk089",
    question: "How high may cargo extend above the top of a vehicle's sides?",
    options: ["No limit if secured", "4 feet above the trailer bed", "The maximum height varies by state but cargo must be secured regardless of height", "6 inches"],
    answer: 2,
    explanation: "Height limits vary by state (commonly 13 feet 6 inches overall). Cargo must comply with state height restrictions and be properly secured.",
  },
  // ── FUELING SAFETY ────────────────────────────────────────────────────────────
  {
    id: "gk090",
    question: "Before fueling a CMV, you should:",
    options: ["Turn the engine off", "Leave the engine running to keep batteries charged", "Set the transmission to neutral only", "Start fueling immediately"],
    answer: 0,
    explanation: "Turn off the engine before fueling. Fueling with the engine running creates a fire hazard due to fuel vapors.",
  },
  {
    id: "gk091",
    question: "When fueling a vehicle, you should NOT:",
    options: ["Turn the ignition off", "Use a cell phone near the fuel nozzle", "Ground the vehicle if required", "Use the correct fuel type"],
    answer: 1,
    explanation: "Cell phones near fuel nozzles can potentially create sparks. Avoid using electronic devices while fueling.",
  },
  // ── MOUNTAIN DRIVING ──────────────────────────────────────────────────────────
  {
    id: "gk092",
    question: "When driving downhill on a long, steep grade, you should:",
    options: ["Use a lower gear and rely mainly on engine braking; use service brakes intermittently if needed", "Use a high gear to maintain control with brakes", "Drive in neutral to save fuel", "Apply the parking brake continuously"],
    answer: 0,
    explanation: "Engage a lower gear before starting down. Engine braking slows the vehicle; use service brakes to reduce speed by about 5 mph, then release, repeat as needed.",
  },
  {
    id: "gk093",
    question: "What is the 'escape ramp' (runaway truck ramp) designed to do?",
    options: ["Allow trucks to avoid toll booths", "Stop runaway vehicles whose brakes have failed on a downgrade", "Provide an alternate route around traffic", "Allow trucks to rest legally on a grade"],
    answer: 1,
    explanation: "Runaway truck ramps are safety devices — gravel, sand, or steep uphill ramps — designed to stop trucks with brake failure on steep downgrades.",
  },
  {
    id: "gk094",
    question: "What is 'brake fade'?",
    options: ["A normal reduction in brake noise after break-in", "Reduced braking effectiveness caused by overheating of brakes", "ABS disengaging on low-traction surfaces", "Air escaping from the brake lines"],
    answer: 1,
    explanation: "Brake fade is the loss of braking effectiveness caused by heat buildup from overuse, especially on long downgrades.",
  },
  {
    id: "gk095",
    question: "When climbing a steep grade, you should:",
    options: ["Downshift after your speed has dropped significantly to maintain gear engagement", "Upshift as early as possible", "Downshift before reaching the grade to avoid losing speed and momentum on the hill", "Disconnect the engine brake"],
    answer: 2,
    explanation: "Downshift before reaching the grade. Trying to downshift after your speed has dropped can cause you to stall or lose gears.",
  },
  // ── DISTRACTED AND FATIGUED DRIVING ──────────────────────────────────────────
  {
    id: "gk096",
    question: "Using a hand-held cell phone while driving a CMV is:",
    options: ["Legal if you keep one hand on the wheel", "Prohibited — it is a serious traffic violation that can result in CDL disqualification", "Legal for calls under 2 minutes", "Only prohibited in school zones"],
    answer: 1,
    explanation: "Federal law prohibits using a hand-held mobile phone while operating a CMV. Violations can result in significant fines and CDL disqualification.",
  },
  {
    id: "gk097",
    question: "Texting while driving a CMV is:",
    options: ["Legal if stopped at a red light", "Legal if using voice-to-text", "Prohibited and a disqualifying offense", "Only prohibited at night"],
    answer: 2,
    explanation: "Texting while driving a CMV is strictly prohibited under federal law and is a serious traffic violation that can result in CDL disqualification.",
  },
  {
    id: "gk098",
    question: "Signs of driver fatigue include:",
    options: ["Increased fuel consumption", "Difficulty focusing, drifting from your lane, missing exits, and blinking frequently", "Earlier-than-expected arrival times", "Better fuel economy"],
    answer: 1,
    explanation: "Fatigue signs include difficulty focusing, missing exits, lane drifting, yawning, and heavy eyelids. Stop and rest immediately.",
  },
  {
    id: "gk099",
    question: "The best remedy for driver fatigue is:",
    options: ["Caffeine and energy drinks", "Turning up the radio", "Opening the window", "Sleep"],
    answer: 3,
    explanation: "Only adequate sleep truly combats fatigue. Caffeine and other stimulants are temporary and can mask dangerous sleepiness.",
  },
  // ── RAILROAD CROSSINGS ────────────────────────────────────────────────────────
  {
    id: "gk100",
    question: "When approaching a railroad crossing, a CMV driver must:",
    options: ["Stop only if gates are down or lights are flashing", "Always slow down, look both ways, and be prepared to stop", "Only yield if a train is visible", "Never stop on the tracks"],
    answer: 1,
    explanation: "Always slow down and look both ways at railroad crossings. Stop if required (for certain vehicle types or if a train is coming).",
  },
  {
    id: "gk101",
    question: "Which vehicles must ALWAYS stop at railroad crossings?",
    options: ["Only school buses", "Buses transporting passengers, school buses, vehicles carrying certain hazmat, and vehicles with cargo requiring specific handling", "Only vehicles over 80,000 lbs", "All CMVs regardless of cargo"],
    answer: 1,
    explanation: "Buses, school buses, and vehicles carrying passengers or certain hazmat must stop at all railroad crossings, regardless of whether a train is present.",
  },
  {
    id: "gk102",
    question: "Before crossing railroad tracks, you should check that there is enough space on the other side for your vehicle. Why?",
    options: ["To avoid blocking pedestrian traffic", "So you don't block the crossing and get stuck on the tracks", "Because backing across tracks is illegal", "To check for oncoming vehicle traffic"],
    answer: 1,
    explanation: "Never begin crossing tracks unless you have room to completely clear the tracks on the other side. Getting stuck on tracks risks a catastrophic collision.",
  },
  // ── ACCIDENTS ─────────────────────────────────────────────────────────────────
  {
    id: "gk103",
    question: "If you are in an accident, your first priority is to:",
    options: ["Complete a police report", "Protect the scene, check for injuries, and call for help", "Move your vehicle off the road immediately", "Exchange insurance information"],
    answer: 1,
    explanation: "After an accident, secure the scene to prevent further collisions, check for injuries, and call emergency services.",
  },
  {
    id: "gk104",
    question: "After an accident in which someone is injured, what should you NOT do?",
    options: ["Call 911", "Stay at the scene", "Try to move an injured person unless there is immediate danger (like fire)", "Secure the scene with warning devices"],
    answer: 2,
    explanation: "Do not move injured persons unless there is an immediate life-threatening hazard (fire, etc.). Moving an injured person can worsen spinal or internal injuries.",
  },
  // ── VEHICLE SYSTEMS ───────────────────────────────────────────────────────────
  {
    id: "gk105",
    question: "What does the tractor protection valve do?",
    options: ["Protects the engine from overheating", "Keeps the tractor's air supply intact if the trailer breaks away or develops a severe air leak", "Controls the fifth wheel locking mechanism", "Controls the spring brakes"],
    answer: 1,
    explanation: "The tractor protection valve closes automatically if trailer air pressure drops severely, preserving tractor air so the driver can stop safely.",
  },
  {
    id: "gk106",
    question: "What is the purpose of the glad hands on a combination vehicle?",
    options: ["To secure the trailer doors", "To connect the air lines from the tractor to the trailer", "To lock the landing gear", "To connect electrical lines for lights"],
    answer: 1,
    explanation: "Glad hands are coupling devices that connect the tractor's service and emergency air lines to the trailer.",
  },
  {
    id: "gk107",
    question: "Dual air brakes use two separate air systems because:",
    options: ["It makes braking smoother", "If one system fails the other still provides braking ability", "It allows the front and rear brakes to work independently for cornering", "It reduces air pressure buildup"],
    answer: 1,
    explanation: "Dual air brake systems provide a safety backup. If one system leaks or fails, the other maintains braking ability.",
  },
  {
    id: "gk108",
    question: "Spring brakes are engaged (applied) when:",
    options: ["Air pressure is high", "The driver presses the brake pedal", "Air pressure drops to a low level (around 20-45 psi)", "The engine is running"],
    answer: 2,
    explanation: "Spring brakes are mechanical brakes held released by air pressure. When air pressure drops too low, springs apply the brakes automatically.",
  },
  {
    id: "gk109",
    question: "What is 'modulating' the spring brakes?",
    options: ["Charging the spring brake chambers", "Using the spring brake control valve to gradually apply and release the spring brakes", "Releasing the spring brakes by building air pressure", "Pumping the brakes on ice"],
    answer: 1,
    explanation: "The modulating valve allows gradual spring brake application, useful when service brakes have failed.",
  },
  // ── ENVIRONMENTAL AND FUEL EFFICIENCY ─────────────────────────────────────────
  {
    id: "gk110",
    question: "Idling a diesel engine for long periods:",
    options: ["Is always efficient and warms the engine properly", "Wastes fuel, increases engine wear, and contributes to air pollution", "Is recommended for cold weather parking", "Has no effect on the engine"],
    answer: 1,
    explanation: "Excessive idling wastes fuel (roughly 1 gallon per hour for a diesel), increases engine wear, and produces unnecessary emissions.",
  },
  {
    id: "gk111",
    question: "Which practice most reduces fuel consumption?",
    options: ["Driving at the highest possible speed", "Smooth acceleration and deceleration, maintaining steady speed", "Frequent braking and acceleration", "Overloading the trailer"],
    answer: 1,
    explanation: "Smooth driving — gradual acceleration and deceleration, maintaining steady speed — reduces fuel consumption and vehicle wear.",
  },
  // ── TIRE SAFETY ───────────────────────────────────────────────────────────────
  {
    id: "gk112",
    question: "What does over-inflated tires cause?",
    options: ["Better fuel economy with no downsides", "Uneven wear in the center of the tread and reduced traction", "Better traction in wet conditions", "Reduced stopping distance"],
    answer: 1,
    explanation: "Over-inflated tires wear excessively in the center, have a harder ride, and may be more susceptible to damage from road hazards.",
  },
  {
    id: "gk113",
    question: "Under-inflated tires can cause:",
    options: ["Better traction", "Tire failure due to heat buildup and excess flexing", "Improved fuel economy", "Reduced braking distance"],
    answer: 1,
    explanation: "Under-inflation causes excessive heat buildup in the sidewall, which can lead to tire blowout.",
  },
  {
    id: "gk114",
    question: "Dual tires must NOT touch because:",
    options: ["It reduces stability", "Contact can cause heat buildup and tire failure", "It is illegal under all circumstances", "It damages the axle"],
    answer: 1,
    explanation: "Dual tires that touch (from uneven wear, mixed sizes, or between-axle objects) create excessive heat leading to blowout.",
  },
  {
    id: "gk115",
    question: "A recapped (retreaded) tire may NOT be used on:",
    options: ["Drive axles", "Trailer axles", "Front (steer) axles of CMVs in interstate commerce", "Any axle of a CMV"],
    answer: 2,
    explanation: "Recapped tires are prohibited on the front (steering) axles of CMVs in interstate commerce due to safety concerns.",
  },
  // ── LIGHTING AND SIGNALS ──────────────────────────────────────────────────────
  {
    id: "gk116",
    question: "Clearance lights on a CMV must be:",
    options: ["White in the front, red in the rear, and amber on the sides", "All amber", "All red", "Only required at night"],
    answer: 0,
    explanation: "Clearance lights identify the width of a vehicle: white/amber in front, red in rear, amber on the sides.",
  },
  {
    id: "gk117",
    question: "When must your vehicle's headlights be turned on?",
    options: ["Only at night", "From sunset to sunrise, and when visibility is reduced to less than 500 feet", "Only when required by law", "When driving in fog or heavy precipitation"],
    answer: 1,
    explanation: "Headlights are required from sunset to sunrise and whenever visibility drops below 500 feet (conditions vary by state).",
  },
  // ── WATER AND BRIDGE CROSSINGS ────────────────────────────────────────────────
  {
    id: "gk118",
    question: "After driving through a puddle or flooded section, you should:",
    options: ["Drive faster to dry the brakes quickly", "Test your brakes gently to dry them out", "Avoid braking for at least 5 minutes", "Increase speed immediately"],
    answer: 1,
    explanation: "Wet brakes have reduced effectiveness. After going through water, gently apply the brakes while moving to generate heat and dry them.",
  },
  // ── PASSING AND LANE USE ──────────────────────────────────────────────────────
  {
    id: "gk119",
    question: "When is it safe to pass another vehicle on a two-lane road?",
    options: ["Any time if you can see ahead", "Only on straight sections with clear sight distance, no opposing traffic, and legal passing zones", "On curves if you accelerate quickly", "Never on a two-lane road with a CMV"],
    answer: 1,
    explanation: "Pass only when you have a clear sight distance, it is legal, and you can complete the pass before meeting opposing traffic.",
  },
  {
    id: "gk120",
    question: "Before changing lanes, you should:",
    options: ["Check only the mirror on the side you are moving to", "Check mirrors on both sides, signal, and check blind spots", "Signal and move immediately", "Honk to warn other drivers"],
    answer: 1,
    explanation: "Before changing lanes: check all mirrors for vehicles in and around the lane, signal your intent, check blind spots, and change lanes smoothly.",
  },
  // ── ALCOHOL AND DRUGS ─────────────────────────────────────────────────────────
  {
    id: "gk121",
    question: "The blood alcohol concentration (BAC) legal limit for CDL holders operating a CMV is:",
    options: ["0.08%", "0.06%", "0.04%", "0.02%"],
    answer: 2,
    explanation: "The legal BAC limit for CMV drivers is 0.04%, which is half the standard 0.08% limit for regular drivers.",
  },
  {
    id: "gk122",
    question: "A CDL holder may be disqualified from driving if found to have a BAC of 0.04% or more while:",
    options: ["Off duty in a personal vehicle", "On duty operating a CMV", "Operating any motor vehicle", "Operating a vehicle weighing over 26,001 lbs only"],
    answer: 1,
    explanation: "The 0.04% BAC limit applies when operating a CMV. This is half the standard legal limit for passenger vehicles.",
  },
  {
    id: "gk123",
    question: "Under federal law, a CDL driver is 'out of service' and cannot drive if they have a BAC of:",
    options: ["0.01% or higher", "0.04% or higher", "0.08% or higher", "Any detectable amount"],
    answer: 1,
    explanation: "A CMV driver is placed out of service when BAC is 0.04% or higher. They may not drive until 24 hours have passed.",
  },
  {
    id: "gk124",
    question: "A first offense conviction for DUI while driving a CMV results in CDL disqualification for at least:",
    options: ["30 days", "90 days", "1 year", "Life"],
    answer: 2,
    explanation: "A first DUI offense in a CMV results in at least a 1-year CDL disqualification (3 years if transporting hazmat).",
  },
  {
    id: "gk125",
    question: "What happens to a CDL holder convicted of a DUI in a personal (non-CMV) vehicle?",
    options: ["No effect on CDL", "CDL is suspended or revoked just as if it were in a CMV", "Only a warning", "CDL is restricted to in-state only"],
    answer: 1,
    explanation: "DUI convictions in ANY vehicle — including personal cars — can result in CDL disqualification.",
  },
  // ── CDL DISQUALIFICATIONS ─────────────────────────────────────────────────────
  {
    id: "gk126",
    question: "A driver will be disqualified from operating a CMV for life (permanently) if they:",
    options: ["Receive two speeding tickets in a year", "Are convicted of a second DUI in a CMV", "Lose their CDL for exceeding hours of service limits", "Fail a vehicle inspection twice"],
    answer: 1,
    explanation: "A second DUI conviction (or certain other major offenses) in a CMV results in a lifetime CDL disqualification.",
  },
  {
    id: "gk127",
    question: "Which of the following is a 'serious traffic violation' that can result in CDL disqualification after two offenses in 3 years?",
    options: ["Parking violations", "Speeding 15+ mph over the limit while driving a CMV", "Equipment violations", "Log book errors"],
    answer: 1,
    explanation: "Serious traffic violations include excessive speeding (15+ mph over), reckless driving, improper lane changes, and following too close. Two in 3 years = 60-day disqualification.",
  },
  {
    id: "gk128",
    question: "Leaving the scene of an accident while driving a CMV results in:",
    options: ["A warning", "At least a 1-year CDL disqualification", "License suspension for 30 days", "A fine only"],
    answer: 1,
    explanation: "Leaving the scene of an accident involving a CMV is a major offense resulting in at least a 1-year CDL disqualification.",
  },
  // ── DRIVING IN SPECIAL CONDITIONS ─────────────────────────────────────────────
  {
    id: "gk129",
    question: "When driving in heavy snow or ice, you should:",
    options: ["Use cruise control to maintain steady speed", "Increase following distance significantly and reduce speed", "Drive at the normal speed limit", "Turn off the ABS system"],
    answer: 1,
    explanation: "On snow or ice, stopping distances are dramatically increased. Reduce speed well below posted limits and greatly increase following distance.",
  },
  {
    id: "gk130",
    question: "In a whiteout blizzard that reduces visibility to near zero, you should:",
    options: ["Drive at half the posted speed limit", "Pull off the road in a safe location and wait for conditions to improve", "Follow the vehicle ahead very closely to use their lights as a guide", "Turn off your lights to avoid blinding others"],
    answer: 1,
    explanation: "If visibility is near zero, it is safest to pull completely off the road, activate hazard lights, and wait for conditions to improve.",
  },
  {
    id: "gk131",
    question: "What is the proper technique for braking on slippery roads?",
    options: ["Apply brakes hard and fast", "Pump the brakes rapidly", "Apply steady, moderate pressure — do not exceed the traction limit", "Use only the engine brake"],
    answer: 2,
    explanation: "On slippery roads, apply firm but steady pressure, staying within the traction limit. Hard braking locks wheels and causes skids.",
  },
  {
    id: "gk132",
    question: "What should you do before driving into a flooded road?",
    options: ["Drive through at full speed to avoid getting stuck", "Determine the depth of the water before proceeding; avoid it if uncertain", "Use a lower gear and accelerate through", "Turn on your hazard lights and proceed normally"],
    answer: 1,
    explanation: "Never drive into unknown flood water. Assess depth first — water that appears shallow may be much deeper and can sweep a vehicle off the road.",
  },
  // ── CURVES AND ROLLOVER PREVENTION ────────────────────────────────────────────
  {
    id: "gk133",
    question: "The most common cause of CMV rollovers is:",
    options: ["Brake failure", "Driving too fast in a curve or on a ramp", "Overloading the front axle", "Sudden crosswinds alone"],
    answer: 1,
    explanation: "Taking curves or highway ramps too fast is the leading cause of CMV rollovers. Slow down before entering curves.",
  },
  {
    id: "gk134",
    question: "To prevent rollovers, you should:",
    options: ["Accelerate through curves to maintain stability", "Slow down before curves and ramps, especially when loaded", "Keep all weight in the trailer nose", "Use only the service brakes, never the engine brake"],
    answer: 1,
    explanation: "Always slow down before curves. High center of gravity and heavy loads make CMVs especially prone to rollover when taking curves too fast.",
  },
  {
    id: "gk135",
    question: "High center of gravity increases rollover risk because:",
    options: ["It improves traction", "The vehicle's weight is higher up, making it easier to tip", "It reduces wind resistance", "It lowers the suspension"],
    answer: 1,
    explanation: "A high center of gravity makes a vehicle more top-heavy. Less lateral force is required to tip it over in a curve or during sudden maneuvers.",
  },
  // ── GENERAL KNOWLEDGE — MISCELLANEOUS ────────────────────────────────────────
  {
    id: "gk136",
    question: "What does GVWR stand for?",
    options: ["Gross Vehicle Weight Rating", "General Vehicle Width Regulation", "Gross Velocity and Weight Rating", "General Vehicular Weight Requirement"],
    answer: 0,
    explanation: "GVWR is the Gross Vehicle Weight Rating — the maximum weight the manufacturer rates for a single vehicle including the vehicle and its contents.",
  },
  {
    id: "gk137",
    question: "What does GCWR stand for?",
    options: ["Gross Cargo Weight Regulation", "Gross Combination Weight Rating", "General Combined Weight Restriction", "Government CMV Weight Requirement"],
    answer: 1,
    explanation: "GCWR is the Gross Combination Weight Rating — the maximum weight rated for a combination of tractor and trailer(s).",
  },
  {
    id: "gk138",
    question: "A Medical Examiner's Certificate is required for a CDL driver because:",
    options: ["It is just a formality", "Drivers must meet health and physical standards to safely operate CMVs", "It is only required for drivers over 65", "Only new drivers need one"],
    answer: 1,
    explanation: "CDL drivers must be medically certified every 2 years (or more frequently if required). Medical fitness is essential for the safety of CMV operation.",
  },
  {
    id: "gk139",
    question: "Which of the following health conditions can disqualify a driver from holding a CDL?",
    options: ["Common cold", "Epilepsy (seizure disorders) without adequate medical control", "Corrected vision with glasses", "High blood pressure controlled with medication"],
    answer: 1,
    explanation: "Uncontrolled epilepsy (seizures) is disqualifying. Some conditions like controlled blood pressure and corrected vision are acceptable with proper treatment.",
  },
  {
    id: "gk140",
    question: "A CDL holder must notify their employer within _____ of any traffic conviction in any vehicle.",
    options: ["24 hours", "3 days", "30 days", "60 days"],
    answer: 2,
    explanation: "CDL holders must notify their employer within 30 days of any traffic conviction — in any vehicle, including a personal car.",
  },
  {
    id: "gk141",
    question: "A CDL holder must notify the state licensing agency within _____ of a DUI conviction.",
    options: ["24 hours", "30 days", "60 days", "90 days"],
    answer: 1,
    explanation: "CDL holders must notify the state that issued their CDL of any DUI conviction within 30 days.",
  },
  {
    id: "gk142",
    question: "You must have a CDL in which state?",
    options: ["The state where you work", "The state where your carrier is based", "Your state of domicile (where you live)", "Any state where you drive"],
    answer: 2,
    explanation: "A CDL must be issued by your state of domicile — where you live. You may only hold one CDL from one state at a time.",
  },
  {
    id: "gk143",
    question: "What is the maximum number of CDLs a driver may hold?",
    options: ["As many as needed for different states", "Two — one per state of regular operation", "One — only the state of domicile", "No limit"],
    answer: 2,
    explanation: "A driver may hold only one CDL, issued by their state of domicile. Holding multiple CDLs from different states is prohibited.",
  },
  // ── COMBINATION VEHICLE KNOWLEDGE ─────────────────────────────────────────────
  {
    id: "gk144",
    question: "What is 'jackknifing'?",
    options: ["When the trailer pushes the tractor to one side, bending the combination at the fifth wheel", "When the trailer axles lock up and the trailer swings out to form a 90-degree angle", "When the landing gear collapses", "When the trailer separates from the tractor"],
    answer: 1,
    explanation: "Jackknifing occurs when the trailer's rear axles lock, causing the trailer to swing out relative to the tractor, folding the combination like a jackknife.",
  },
  {
    id: "gk145",
    question: "What causes trailer jackknife?",
    options: ["Steering axle wheel lockup", "Excessive speed on a curve with no braking", "Drive axle brake lockup — rear of the tractor skids", "Trailer brake lockup — rear trailer wheels skid"],
    answer: 3,
    explanation: "Trailer jackknife is caused by the trailer wheels locking, allowing the trailer to swing outward. Drive axle lockup causes tractor jackknife.",
  },
  {
    id: "gk146",
    question: "To prevent a jackknife when braking hard:",
    options: ["Apply trailer brakes before tractor brakes", "Apply tractor brakes as hard as possible and steer into the skid", "Brake progressively and avoid locking any wheels", "Disconnect the trailer"],
    answer: 2,
    explanation: "Progressive braking prevents wheel lockup. ABS helps prevent lockup automatically. Avoiding wheel lockup prevents jackknifing.",
  },
  {
    id: "gk147",
    question: "What must you check for when coupling a fifth-wheel trailer?",
    options: ["Only that the trailer is level", "That the kingpin is properly locked in the fifth wheel jaws — look for the safety latch", "Only the air line connections", "Only the trailer lights"],
    answer: 1,
    explanation: "After coupling, test the connection by pulling against the kingpin with the tractor and confirm the jaws are fully locked by visual inspection.",
  },
  {
    id: "gk148",
    question: "When uncoupling a tractor from its trailer, what should you do first?",
    options: ["Remove the glad hands", "Park on level ground, apply parking brakes, and chock trailer wheels if needed", "Disconnect the landing gear", "Release the kingpin"],
    answer: 1,
    explanation: "Before uncoupling, secure the trailer with parking brakes and wheel chocks to prevent it from rolling.",
  },
  // ── MISCELLANEOUS / FINAL QUESTIONS ───────────────────────────────────────────
  {
    id: "gk149",
    question: "What does ABS (Anti-lock Braking System) do?",
    options: ["Increases braking force beyond normal limits", "Prevents wheel lockup by automatically modulating brake pressure", "Applies brakes automatically when the vehicle speeds up", "Replaces the need for proper braking distance"],
    answer: 1,
    explanation: "ABS detects wheel lockup during braking and rapidly modulates brake pressure to prevent skidding, helping drivers maintain steering control.",
  },
  {
    id: "gk150",
    question: "When ABS is activated, you should:",
    options: ["Pump the brakes rapidly", "Steer around the obstacle while continuing to apply firm, steady brake pressure", "Release the brakes entirely", "Apply the parking brake"],
    answer: 1,
    explanation: "ABS allows you to steer while braking. Apply firm, steady pressure — do not pump. ABS will modulate automatically.",
  },
  {
    id: "gk151",
    question: "What is the correct way to use a fire extinguisher?",
    options: ["Aim at the top of the flames and spray side to side", "Aim at the base of the fire and sweep from side to side", "Hold it vertical and spray straight up", "Squeeze and hold from as far away as possible"],
    answer: 1,
    explanation: "Use the PASS technique: Pull pin, Aim at the base, Squeeze the handle, Sweep side to side.",
  },
  {
    id: "gk152",
    question: "What type of fire extinguisher is required on a CMV?",
    options: ["Any type available", "A B:C rated extinguisher (or A:B:C)", "Only water-based extinguishers", "CO2 only"],
    answer: 1,
    explanation: "CMVs must have a B:C rated fire extinguisher. A:B:C rated extinguishers (suitable for all fires including ordinary combustibles) are also acceptable.",
  },
  {
    id: "gk153",
    question: "What is the minimum fire extinguisher rating required for vehicles with GVWR over 26,000 lbs?",
    options: ["5 B:C", "10 B:C", "20 B:C", "A:B:C rated"],
    answer: 1,
    explanation: "Vehicles with GVWR over 26,000 lbs require a fire extinguisher with a rating of at least 10 B:C.",
  },
  {
    id: "gk154",
    question: "What is the purpose of retarders on a CMV?",
    options: ["To increase engine power on uphills", "To slow the vehicle using engine compression or hydraulic systems, reducing brake wear", "To lock up the trailer wheels in an emergency", "To prevent ABS from engaging"],
    answer: 1,
    explanation: "Retarders (engine, hydraulic, or electric) help control speed on downgrades and reduce wear on service brakes.",
  },
  {
    id: "gk155",
    question: "When should retarders be turned off?",
    options: ["On highways", "On slippery road surfaces where the extra braking could cause wheel spin or skids", "When driving uphill", "Never — keep them on at all times"],
    answer: 1,
    explanation: "Turn off retarders on wet, icy, or slippery roads. They can cause rear wheels to skid or spin in low-traction conditions.",
  },
  {
    id: "gk156",
    question: "Where is the safest place to be during a lightning storm when driving a CMV?",
    options: ["Under a bridge", "Outside the vehicle under a tree", "Inside the cab with windows up", "On an open road away from trees"],
    answer: 2,
    explanation: "Stay inside the vehicle during a lightning storm. The metal body conducts electricity around the occupants. Avoid open areas on foot.",
  },
  {
    id: "gk157",
    question: "When should you stop at a weigh station?",
    options: ["Only if you think you are overweight", "Only on Interstates", "Whenever the weigh station is open and signs require vehicles to stop", "Only if a DOT officer waves you in"],
    answer: 2,
    explanation: "Drivers must stop at all open weigh stations unless directed otherwise by an officer. Bypassing an open weigh station is a violation.",
  },
  {
    id: "gk158",
    question: "What is the purpose of a weigh station?",
    options: ["To collect fuel taxes", "To verify that vehicles comply with size and weight limits and to check for safety violations", "To provide free parking for CMVs", "Only to check hazmat placard compliance"],
    answer: 1,
    explanation: "Weigh stations check vehicle weight limits and may include safety inspections for equipment defects, license checks, and documentation reviews.",
  },
  {
    id: "gk159",
    question: "What is the main danger of driving with cargo that is loaded too high (high center of gravity)?",
    options: ["Increased fuel consumption only", "Reduced visibility for the driver", "Increased risk of rollover", "Reduced traction on the front axle"],
    answer: 2,
    explanation: "A high center of gravity makes the vehicle more top-heavy and dramatically increases rollover risk, especially in curves and during emergency maneuvers.",
  },
  {
    id: "gk160",
    question: "What effect does reduced air pressure in tires have on fuel economy and safety?",
    options: ["Improves fuel economy and safety", "Has no effect if driving slowly", "Increases fuel consumption and risk of tire failure from heat buildup", "Only affects fuel economy, not safety"],
    answer: 2,
    explanation: "Under-inflated tires create more rolling resistance (using more fuel) and generate heat that can cause blowouts.",
  },
  {
    id: "gk161",
    question: "What is the 'danger zone' for a large commercial truck?",
    options: ["Only directly behind the trailer", "The area around the vehicle where the driver has limited or no visibility", "Only the right side of the vehicle", "Only in front of the truck"],
    answer: 1,
    explanation: "The danger zone (no-zone) includes all areas around a truck where visibility is limited: in front, behind, and on both sides of the cab.",
  },
  {
    id: "gk162",
    question: "What is the best way to ensure you are properly rested before a long trip?",
    options: ["Drink extra coffee before starting", "Get adequate sleep the night before and during required rest breaks", "Take a short rest break every few hours regardless of fatigue", "Drive at night when traffic is lighter"],
    answer: 1,
    explanation: "Adequate sleep before the trip and during required rest periods is the only effective way to prevent fatigue-related accidents.",
  },
  {
    id: "gk163",
    question: "What is 'perception distance' in the context of stopping distance?",
    options: ["The distance traveled while you are moving your foot from accelerator to brake", "The distance traveled from when you see a hazard to when your brain recognizes it as a hazard", "The distance the vehicle travels while the brakes are applied", "The distance between your vehicle and the hazard when you first see it"],
    answer: 1,
    explanation: "Perception distance is the distance your vehicle travels from the moment you see a hazard until your brain recognizes the danger.",
  },
  {
    id: "gk164",
    question: "What is 'reaction distance'?",
    options: ["The distance traveled while the brakes are actually stopping the vehicle", "The distance traveled from when you see a hazard to when your brain recognizes it", "The distance traveled from when you decide to brake until your foot actually moves the brake", "The total stopping distance"],
    answer: 2,
    explanation: "Reaction distance is the distance your vehicle travels from the moment your brain recognizes the hazard until your foot begins to move to the brake.",
  },
  {
    id: "gk165",
    question: "At 55 mph, how far does a vehicle travel in 1 second?",
    options: ["About 40 feet", "About 55 feet", "About 81 feet", "About 100 feet"],
    answer: 2,
    explanation: "At 55 mph, a vehicle travels approximately 80–81 feet per second. This is important for calculating stopping distances.",
  },
  {
    id: "gk166",
    question: "What is meant by 'smooth driving'?",
    options: ["Never exceeding 45 mph", "Making gradual, gentle accelerations, decelerations, and steering inputs", "Using the highest gear at all times", "Driving only on smooth road surfaces"],
    answer: 1,
    explanation: "Smooth driving involves gentle, gradual inputs to accelerator, brakes, and steering. It reduces fuel consumption, wear, and the chance of losing control.",
  },
  {
    id: "gk167",
    question: "What is an 'escape route' while driving?",
    options: ["A route to avoid weigh stations", "A planned alternate path the driver can take in an emergency to avoid a collision", "The path to the nearest rest area", "A lane for emergency vehicles only"],
    answer: 1,
    explanation: "Always identify an escape route — a path you can take to avoid a collision if the situation ahead changes suddenly.",
  },
  {
    id: "gk168",
    question: "When approaching an intersection, you should:",
    options: ["Speed up to clear it before traffic changes", "Cover the brake (position foot over brake without pressing) to reduce reaction time", "Always stop regardless of light color", "Use the left turn lane for better visibility"],
    answer: 1,
    explanation: "Covering the brake means positioning your foot over it without pressing, so you can respond faster if needed at a potentially hazardous intersection.",
  },
  {
    id: "gk169",
    question: "What is the proper hand position when backing a CMV straight?",
    options: ["Top of the wheel with both hands", "9 and 3 o'clock on the wheel", "One hand at the top of the wheel", "Bottom of the wheel with one hand"],
    answer: 2,
    explanation: "When backing, use one hand at the top of the wheel. Turning the top of the wheel to the right turns the vehicle to the right when reversing.",
  },
  {
    id: "gk170",
    question: "A 'No-Zone' around a large truck includes:",
    options: ["Only the area directly behind the trailer", "Directly in front, directly behind, and on each side near the trailer", "Only the right side", "Only the left side"],
    answer: 1,
    explanation: "No-Zones are the blind spots around large vehicles: in front of the cab, directly behind the trailer, and along both sides where the driver cannot see.",
  },
  {
    id: "gk171",
    question: "What should you do if another vehicle cuts in front of you closely?",
    options: ["Honk and accelerate to maintain following distance", "Flash your high beams", "Increase your following distance to compensate and slow if necessary", "Stay in the same lane and maintain your speed"],
    answer: 2,
    explanation: "When cut off, ease off the accelerator to increase your following distance and create a safe space buffer.",
  },
  {
    id: "gk172",
    question: "What is the most important thing to do to avoid drowsy driving?",
    options: ["Drink caffeinated beverages frequently", "Schedule enough time to get adequate sleep before driving", "Drive only during daylight hours", "Keep the cab temperature cold"],
    answer: 1,
    explanation: "The only real defense against drowsy driving is adequate sleep. Plan your schedule to allow sufficient time for rest before and during long trips.",
  },
  {
    id: "gk173",
    question: "What is the speed limit in a school zone unless otherwise posted?",
    options: ["15 mph", "20 mph", "25 mph", "Depends on the state"],
    answer: 3,
    explanation: "School zone speed limits vary by state, typically ranging from 15 to 25 mph. Always obey posted school zone signs.",
  },
  {
    id: "gk174",
    question: "Before crossing a railroad crossing with a load of hazardous materials, you must:",
    options: ["Stop and check that there is no train, then proceed carefully", "Only stop if required by the type of hazmat being carried", "Stop, look and listen for trains in both directions, and proceed only when safe", "Call dispatch to verify the crossing is safe"],
    answer: 2,
    explanation: "Hazmat-carrying vehicles must stop at railroad crossings, look and listen for trains in both directions, and only cross when safe.",
  },
  {
    id: "gk175",
    question: "Which of the following is true about commercial vehicle inspections by law enforcement?",
    options: ["Officers can only inspect vehicles at weigh stations", "Officers may inspect vehicles at any time; drivers must cooperate and allow the inspection", "Inspections require advance notice", "Only the DOT can perform inspections"],
    answer: 1,
    explanation: "Law enforcement may conduct vehicle inspections at any time. Drivers are required to cooperate and provide documentation.",
  },
  {
    id: "gk176",
    question: "What is a Level 1 DOT inspection?",
    options: ["Only a check of driver's license and medical certificate", "A comprehensive roadside inspection of both the driver and vehicle", "Only a vehicle brake inspection", "An inspection triggered by an accident only"],
    answer: 1,
    explanation: "A Level 1 inspection is the most comprehensive roadside inspection — it covers both driver credentials (license, medical, logs) and vehicle safety components.",
  },
  {
    id: "gk177",
    question: "If placed out of service during a DOT inspection, a driver may not operate the CMV until:",
    options: ["They pay a fine", "The out-of-service conditions are corrected", "24 hours have passed", "They notify their employer"],
    answer: 1,
    explanation: "An out-of-service order means the vehicle has serious safety defects or the driver has a serious violation. The vehicle cannot move until the issues are corrected.",
  },
  {
    id: "gk178",
    question: "What is the purpose of the kingpin on a semi-trailer?",
    options: ["To secure the trailer doors", "To connect to the fifth wheel of the tractor", "To attach the landing gear", "To lock the brake drums"],
    answer: 1,
    explanation: "The kingpin is a steel pin underneath the front of the trailer that locks into the fifth wheel of the tractor to couple the units.",
  },
  {
    id: "gk179",
    question: "What are 'splash and spray' suppressors on a CMV?",
    options: ["Devices to clean windshields automatically", "Mudflaps and fender skirts that reduce water spray kicked up by tires", "Drain valves in the fuel tanks", "Windshield washer nozzles"],
    answer: 1,
    explanation: "Splash and spray suppressors (mudflaps, fender extensions) reduce water spray from tires, improving visibility for following drivers.",
  },
  {
    id: "gk180",
    question: "What is the correct procedure for making an emergency stop on the side of a highway?",
    options: ["Stop anywhere and turn on headlights", "Pull off the road as far as possible, turn on 4-way flashers, and place warning devices within 10 minutes", "Stop in the right lane and wave for help", "Stop only in designated emergency pullouts"],
    answer: 1,
    explanation: "Pull as far off the road as possible, turn on hazard lights, and place triangles or flares within 10 minutes to warn oncoming drivers.",
  },
  {
    id: "gk181",
    question: "What is the correct placement of emergency triangles on a divided highway?",
    options: ["100, 200, and 300 feet in front of the vehicle", "10 feet at the traffic side rear, 100 feet behind the vehicle, and 200 feet behind the vehicle", "Evenly spaced 50 feet apart", "Behind the vehicle only"],
    answer: 1,
    explanation: "On a divided highway: one within 10 feet (traffic side, rear), one at 100 feet, one at 200 feet. Direction is based on preventing traffic hazards.",
  },
  {
    id: "gk182",
    question: "What is the purpose of a 'turbocharger' on a diesel engine?",
    options: ["To reduce engine temperature", "To increase engine power by forcing more air into the combustion chamber", "To control the fuel mixture", "To act as a retarder"],
    answer: 1,
    explanation: "A turbocharger compresses air entering the engine, allowing more fuel to burn and increasing power output.",
  },
  {
    id: "gk183",
    question: "What is 'engine braking'?",
    options: ["Using the service brakes in combination with the engine brake", "Using the resistance of the engine to slow the vehicle when the accelerator is released", "Applying the brakes while the engine is running", "Using a compression release brake (Jake brake)"],
    answer: 1,
    explanation: "Engine braking occurs when you release the accelerator and the engine's resistance slows the vehicle — more effective in lower gears.",
  },
  {
    id: "gk184",
    question: "What is a 'compression release brake' (commonly called a Jake brake)?",
    options: ["A type of spring brake", "A supplemental braking system that opens engine exhaust valves to use compression to slow the vehicle", "A hydraulic brake system", "A brake used only on steep upgrades"],
    answer: 1,
    explanation: "A Jake brake (compression release brake) slows the vehicle by opening exhaust valves at top of compression, using the engine as an air compressor.",
  },
  {
    id: "gk185",
    question: "Compression release brakes should be turned off when:",
    options: ["Going downhill", "On wet, icy, or slippery surfaces — it can cause drive wheels to skid", "On long highway stretches", "When driving with a full load"],
    answer: 1,
    explanation: "Engine/compression brakes apply significant retarding force to drive wheels. On slippery surfaces this can cause wheel spin or skids.",
  },
  {
    id: "gk186",
    question: "What does the 'pre-trip inspection' specifically require regarding the cargo area?",
    options: ["Only checking that doors are locked", "Checking that cargo is properly secured, not overloaded, and that it does not obstruct the driver's view or access to emergency equipment", "Only verifying the weight ticket", "Checking only the rear doors"],
    answer: 1,
    explanation: "The cargo area inspection includes verifying proper securement, that weight limits are not exceeded, and that cargo does not impair visibility or block emergency equipment.",
  },
  {
    id: "gk187",
    question: "Steering wheel play (free movement before resistance is felt) should not exceed:",
    options: ["5 degrees (about 1/2 inch on a 20-inch wheel)", "10 degrees", "2 inches for any steering wheel size", "1 inch on a 20-inch wheel"],
    answer: 2,
    explanation: "Excessive steering play indicates worn components. For a 20-inch wheel, more than about 2 inches of free play before resistance indicates a problem.",
  },
  {
    id: "gk188",
    question: "What should you check on windshield wipers during a pre-trip inspection?",
    options: ["Only that they are attached", "That they work properly, the blades are not torn, and washer fluid is full", "Only the wiper speed settings", "That they are the correct brand"],
    answer: 1,
    explanation: "Check that wipers operate correctly, blades are not worn or torn, and washer fluid is adequate for safe operation in adverse weather.",
  },
  {
    id: "gk189",
    question: "When is it safe to drive a CMV with known brake defects?",
    options: ["If the defects are minor", "If you are within 50 miles of a repair facility", "Never — the vehicle must be repaired before driving", "Only on private property"],
    answer: 2,
    explanation: "Brake defects are critical safety issues. A CMV may not be driven with known brake defects that affect safety.",
  },
  {
    id: "gk190",
    question: "What is the correct procedure if your vehicle catches fire while driving?",
    options: ["Continue driving to a fire station", "Pull off the road safely, move people away, call 911, and fight the fire if safe and trained to do so", "Open all vents and windows to let smoke out", "Try to drive into a body of water"],
    answer: 1,
    explanation: "Pull over safely, get everyone away from the vehicle, call 911, and use the fire extinguisher only if you are trained and the fire is small enough to control safely.",
  },
  {
    id: "gk191",
    question: "What type of fire can a B:C fire extinguisher handle?",
    options: ["Wood and paper fires only", "Flammable liquid and electrical fires", "All fires including ordinary combustibles", "Only chemical fires"],
    answer: 1,
    explanation: "B:C extinguishers work on flammable liquid (B) and electrical (C) fires. An A:B:C extinguisher also handles ordinary combustible (A) fires.",
  },
  {
    id: "gk192",
    question: "What does a red warning triangle on the road behind a disabled vehicle mean?",
    options: ["Construction zone ahead", "A vehicle is stopped — use caution and slow down", "The driver needs fuel", "A detour is ahead"],
    answer: 1,
    explanation: "Red emergency triangles behind a disabled vehicle warn approaching drivers to slow down and use caution.",
  },
  {
    id: "gk193",
    question: "Posting the proper placard on a hazmat vehicle is the responsibility of:",
    options: ["Only the shipper", "Only the carrier", "The carrier (the driver's employer) is responsible for placarding the vehicle", "Both the shipper and consignee"],
    answer: 2,
    explanation: "The carrier (trucking company) is responsible for properly placarding the vehicle. The driver must verify placards are correct before driving.",
  },
  {
    id: "gk194",
    question: "What is the purpose of the 'landing gear' on a semi-trailer?",
    options: ["To provide suspension when fully loaded", "Retractable legs that support the front of the trailer when uncoupled from the tractor", "To lock the kingpin to the fifth wheel", "To lower the trailer to the ground for loading"],
    answer: 1,
    explanation: "Landing gear supports the front of the trailer when it is uncoupled. It must be fully retracted before moving.",
  },
  {
    id: "gk195",
    question: "What is the proper way to test the trailer brakes before starting a trip?",
    options: ["Drive slowly and press the brake pedal firmly", "Apply the trailer brakes using the hand valve while moving slowly to check for effectiveness", "Test them only at a weigh station", "Check only the service brake pressure gauge"],
    answer: 1,
    explanation: "Apply the trailer brakes using the hand valve (trailer brake control) to verify they work before beginning the trip.",
  },
  {
    id: "gk196",
    question: "Under what condition is it permissible to drive if you feel very sleepy?",
    options: ["If you will only drive for a short distance", "If you drink enough coffee", "It is never safe to drive when very drowsy", "If you open the windows"],
    answer: 2,
    explanation: "Driving while very drowsy is extremely dangerous. No remedy — coffee, radio, open windows — is reliable. Stop and sleep.",
  },
  {
    id: "gk197",
    question: "Who is required to keep a Record of Duty Status (RODS / logbook)?",
    options: ["Only drivers who drive over 500 miles per day", "All CMV drivers who are subject to Hours of Service regulations", "Only drivers with hazmat endorsements", "Drivers over 65 years old only"],
    answer: 1,
    explanation: "All CMV drivers subject to HOS regulations must maintain a record of duty status — either paper logs or an electronic logging device.",
  },
  {
    id: "gk198",
    question: "What must you do before driving after a sleeper berth rest period?",
    options: ["Nothing special — just start driving", "Check that the vehicle is still in a safe condition and note the beginning of your on-duty period in your log", "Only check tire pressure", "Call dispatch before moving"],
    answer: 1,
    explanation: "After a rest period, ensure the vehicle is still safe (no new defects from parking), then log the start of your new driving period.",
  },
  {
    id: "gk199",
    question: "What is the purpose of a 'runaway truck ramp'?",
    options: ["To provide a legal rest area for trucks", "An emergency escape route to stop trucks that have lost braking ability on a steep downgrade", "A weigh station bypass route", "A shortcut through mountain passes"],
    answer: 1,
    explanation: "Runaway truck ramps are paved or gravel escape paths on steep downgrades designed to stop trucks that have lost brake effectiveness.",
  },
  {
    id: "gk200",
    question: "Massachusetts requires commercial motor vehicle operators to follow all federal motor carrier safety regulations. Which agency sets these rules?",
    options: ["Massachusetts Registry of Motor Vehicles", "FMCSA (Federal Motor Carrier Safety Administration)", "National Transportation Safety Board", "Department of Homeland Security"],
    answer: 1,
    explanation: "The FMCSA (part of the U.S. Department of Transportation) sets federal safety regulations for commercial motor vehicles. States may add requirements but cannot be less restrictive.",
  },
  {
    id: "gk201",
    question: "In Massachusetts, the minimum age to obtain a CDL is:",
    options: ["18 years for all CDL classes", "18 years for intrastate and 21 years for interstate driving", "21 years for all CDL classes", "16 years with employer authorization"],
    answer: 1,
    explanation: "Drivers must be at least 18 to hold a CDL in Massachusetts (intrastate only). Interstate CDL driving requires age 21 or older.",
  },
  {
    id: "gk202",
    question: "When driving in Massachusetts, if you are stopped by State Police for a weight violation, which document must you have available?",
    options: ["Only the vehicle registration", "A valid CDL, medical certificate, vehicle registration, and if applicable shipping papers and hazmat documents", "Only the bill of lading", "Only the DOT number registration"],
    answer: 1,
    explanation: "Officers may request CDL, medical certificate, registration, RODS/ELD, and shipping papers. All required documents must be current and available.",
  },
  {
    id: "gk203",
    question: "What must you do if your CDL expires?",
    options: ["Continue driving until you can renew it", "Stop driving a CMV immediately and renew before operating again", "Renew it within 30 days of expiration", "Only renew if operating interstate"],
    answer: 1,
    explanation: "An expired CDL is invalid. You may not legally operate a CMV with an expired CDL and must renew before driving again.",
  },
  {
    id: "gk204",
    question: "What is the purpose of a 'work zone' speed limit?",
    options: ["To increase traffic flow through construction areas", "To protect construction workers and drivers from crashes in areas where road conditions are altered", "To reduce traffic noise near construction", "Required by federal law regardless of conditions"],
    answer: 1,
    explanation: "Work zone speed limits protect workers and drivers in areas where lanes may be narrowed, workers are present, and road conditions may change unexpectedly.",
  },
  {
    id: "gk205",
    question: "When approaching a work zone, you should:",
    options: ["Maintain your current speed and change lanes immediately", "Slow down, stay alert, comply with all work zone signs, and maintain extra following distance", "Speed up to clear the zone quickly", "Use the shoulder to bypass congestion"],
    answer: 1,
    explanation: "Work zones require reduced speed, increased alertness, compliance with all posted signs, and extra following distance for unexpected stops.",
  },
  // ── LIVESTOCK / SPECIAL CARGO ────────────────────────────────────────────────
  {
    id: "gk206",
    question: "When transporting livestock with false bulkheads (movable dividers), special care is necessary especially when you:",
    options: ["Park at your final destination", "Make a turn or enter a curve", "Accelerate on an open highway", "Start the engine in cold weather"],
    answer: 1,
    explanation: "Livestock can shift their weight suddenly during turns and curves. This can cause the vehicle to lean or tip. False bulkheads help distribute the animals but cannot eliminate the shifting hazard.",
  },
  {
    id: "gk207",
    question: "Why do livestock loads require extra attention to handling compared to other cargo?",
    options: ["Livestock adds no special risk beyond weight", "Animals move around inside the trailer, causing the center of gravity to shift unexpectedly", "Livestock must be weighed at every weigh station", "Animals generate heat that affects tire pressure"],
    answer: 1,
    explanation: "Unlike solid cargo, live animals move freely. Their shifting weight changes the vehicle's handling, stability, and braking characteristics — requiring smoother steering and braking.",
  },
  {
    id: "gk208",
    question: "When hauling livestock, what precaution should you take at the start of a trip?",
    options: ["Drive faster to reach the destination before animals shift weight", "Check cargo within the first 50 miles and be extra cautious in turns due to potential animal movement", "Only check cargo at the destination", "Increase tire pressure to compensate for the live load"],
    answer: 1,
    explanation: "The standard cargo check rule applies — inspect within the first 50 miles. For livestock, also drive with extra smoothness, especially on turns and curves, since animals shift unpredictably.",
  },
  // ── DRUG & ALCOHOL CLEARINGHOUSE ─────────────────────────────────────────────
  {
    id: "gk209",
    question: "What is the FMCSA Drug and Alcohol Clearinghouse?",
    options: ["A state-level drug testing lab for CMV drivers", "A secure federal online database that tracks CDL drivers' drug and alcohol violations and test results", "A voluntary program for carriers to share driver records", "A list of approved substance abuse professionals"],
    answer: 1,
    explanation: "The FMCSA Clearinghouse is a secure federal database containing records of CDL drivers' drug and alcohol violations. Employers must query it before hiring a driver and annually for current employees.",
  },
  {
    id: "gk210",
    question: "If a CDL driver is placed in 'prohibited' status in the FMCSA Drug and Alcohol Clearinghouse, what must state licensing agencies do?",
    options: ["Issue a warning letter to the driver", "Remove or downgrade the driver's commercial driving privileges until the driver completes the return-to-duty process", "Suspend only the hazmat endorsement", "Take no action — the employer handles it"],
    answer: 1,
    explanation: "As of November 2024, state licensing agencies are required to downgrade or remove a CDL holder's commercial privileges when the driver is in 'prohibited' status in the Clearinghouse, until they complete return-to-duty steps.",
  },
  {
    id: "gk211",
    question: "To be removed from 'prohibited' status in the FMCSA Drug and Alcohol Clearinghouse, a driver must:",
    options: ["Simply pass the next scheduled random drug test", "Wait 12 months automatically", "Complete the return-to-duty process: evaluation by a Substance Abuse Professional, required treatment, and a return-to-duty drug test with negative result", "File a written appeal with the FMCSA"],
    answer: 2,
    explanation: "A driver in 'prohibited' status cannot drive a CMV until they complete the full return-to-duty (RTD) process — SAP evaluation, recommended treatment or education, and a negative RTD drug test.",
  },
  {
    id: "gk212",
    question: "Before allowing a new CDL driver to operate a CMV, an employer must:",
    options: ["Only check the driver's paper driving record", "Query the FMCSA Drug and Alcohol Clearinghouse to check for any drug/alcohol violations from previous employers", "Wait 30 days after hiring before querying the Clearinghouse", "Only query the Clearinghouse if the driver will haul hazmat"],
    answer: 1,
    explanation: "Employers are required to query the Clearinghouse before hiring any CDL driver. This pre-employment query reveals drug and alcohol violations the driver may not disclose.",
  },
  // ── ENGLISH PROFICIENCY (2025 FMCSA RULE) ───────────────────────────────────
  {
    id: "gk213",
    question: "Under FMCSA regulations, CDL drivers must be able to read and speak English well enough to:",
    options: ["Only fill out fuel logs", "Converse with officials, understand traffic signs, fill out required reports and paperwork, and respond to official inquiries", "Speak English only in states that require it", "Pass an annual English proficiency test"],
    answer: 1,
    explanation: "Federal regulations require CMV drivers to have sufficient English proficiency to converse with officials, read traffic signs, understand regulations, and complete required paperwork.",
  },
  {
    id: "gk214",
    question: "If a CMV driver cannot sufficiently respond to an officer's questions in English during a roadside inspection, what happens?",
    options: ["The officer must provide a translator", "The driver receives only a warning on the first offense", "The driver is placed out-of-service and receives a violation", "No action is taken if the cargo paperwork is in order"],
    answer: 2,
    explanation: "As of June 2025, FMCSA requires English proficiency for all CMV drivers. A driver unable to respond to officials in English receives a violation and is placed out-of-service.",
  },
  {
    id: "gk215",
    question: "Which of the following is a reason FMCSA requires CDL drivers to have English proficiency?",
    options: ["To eliminate the need for bilingual road signs", "To ensure drivers can read traffic signs, understand safety instructions, and communicate with law enforcement and emergency responders", "To simplify the CDL written test process", "It is only required in states bordering Canada or Mexico"],
    answer: 1,
    explanation: "English proficiency ensures drivers can safely operate on U.S. roads — reading signs, understanding regulations, communicating in emergencies, and completing required documents.",
  },
  // ── ELD REQUIREMENTS ─────────────────────────────────────────────────────────
  {
    id: "gk216",
    question: "Which drivers are required to use an Electronic Logging Device (ELD)?",
    options: [
      "Only drivers hauling hazardous materials",
      "All CMV drivers who are required to keep a Record of Duty Status (RODS), with limited exceptions",
      "Only drivers operating vehicles manufactured after 2000",
      "Only interstate drivers with more than 5 years of experience",
    ],
    answer: 1,
    explanation: "Most CMV drivers required to maintain a RODS/logbook must use an FMCSA-registered ELD. Exceptions include drivers using paper logs for 8 days or fewer in any 30-day period, short-haul drivers exempt from RODS, and pre-2000 engines.",
  },
  {
    id: "gk217",
    question: "An ELD must be registered with:",
    options: [
      "Your state's Department of Motor Vehicles",
      "The FMCSA",
      "The Department of Transportation's safety office",
      "The carrier's insurance company",
    ],
    answer: 1,
    explanation: "ELD providers must register their devices with the FMCSA. Carriers must use only FMCSA-registered ELDs to be in compliance with the ELD mandate.",
  },
  {
    id: "gk218",
    question: "If your ELD malfunctions during a trip, what must you do?",
    options: [
      "Stop driving immediately until the device is repaired",
      "Reconstruct your records using paper logs and note the malfunction; notify the carrier within 24 hours",
      "Continue driving without recording hours of service",
      "Switch to a backup ELD immediately or you will be placed out-of-service",
    ],
    answer: 1,
    explanation: "When an ELD malfunctions, the driver must reconstruct duty status records on paper logs, note the malfunction, and the carrier must repair or replace the device within 8 days. Drivers may continue driving while using paper logs.",
  },
  {
    id: "gk219",
    question: "When stopped for a roadside inspection, how must a driver present ELD records to an enforcement officer?",
    options: [
      "By emailing the records to the officer's department",
      "By displaying them on the ELD screen or providing a printout, or via wireless transfer if the officer requests it",
      "By providing the officer with the carrier's login credentials",
      "Only a printout is acceptable; screen display is not",
    ],
    answer: 1,
    explanation: "ELD records must be displayable on screen, printable, or transferable via wireless methods (Bluetooth or telematics). The driver must be able to produce them for inspectors.",
  },
  {
    id: "gk220",
    question: "Which of the following drivers is EXEMPT from the ELD mandate?",
    options: [
      "A driver operating an interstate route hauling general freight",
      "A driver operating a vehicle with a model year 2000 or older engine",
      "A part-time driver who drives 3 days per week",
      "A driver hauling perishable goods",
    ],
    answer: 1,
    explanation: "Vehicles with engines manufactured before model year 2000 are exempt from the ELD requirement because older engines lack the electronic control module (ECM) that ELDs require to connect to.",
  },
  // ── NON-DOMICILED CDL (2026 FMCSA RULE) ─────────────────────────────────────
  {
    id: "gk221",
    question: "Under the 2026 FMCSA Non-Domiciled CDL rule, which foreign nationals are eligible for a non-domiciled CLP or CDL?",
    options: [
      "All foreign nationals with a valid work permit",
      "Only individuals holding specific employment-based nonimmigrant visa categories such as H-2A or H-2B",
      "Any foreign national driving commercially in the United States",
      "Foreign nationals from countries with a U.S. trade agreement",
    ],
    answer: 1,
    explanation: "The 2026 FMCSA rule restricts non-domiciled CDL/CLP eligibility to individuals with specific employment-based nonimmigrant status, primarily H-2A (temporary agricultural) and H-2B (temporary non-agricultural) visa holders.",
  },
  {
    id: "gk222",
    question: "A non-domiciled CDL is issued to:",
    options: [
      "U.S. citizens who work in another state",
      "Foreign nationals who are domiciled outside the United States but drive a CMV in the U.S.",
      "Drivers who operate in multiple states without a home state",
      "Drivers who lost their home state CDL due to a violation",
    ],
    answer: 1,
    explanation: "A non-domiciled CDL is for individuals whose legal domicile is in a foreign country but who need a CDL to operate a CMV in the United States.",
  },
  // ── HOURS OF SERVICE — 2025/2026 UPDATES ─────────────────────────────────────
  {
    id: "gk223",
    question: "Under the short-haul exception, a property-carrying driver is exempt from keeping a RODS if the driver operates within how many air-miles of the normal work reporting location?",
    options: ["50 air-miles", "100 air-miles", "150 air-miles", "200 air-miles"],
    answer: 2,
    explanation: "The short-haul exception allows drivers within 150 air-miles of their work reporting location to skip the RODS requirement, provided they return to the reporting location and are released within 14 consecutive hours.",
  },
  {
    id: "gk224",
    question: "The '16-hour short-haul exception' allows a property-carrying driver to extend the on-duty window to 16 hours. How often can this exception be used?",
    options: ["Every day", "Once every 7 days", "Once per week (once in any 7-consecutive-day period)", "Twice per month"],
    answer: 2,
    explanation: "The 16-hour short-haul exception can be used once per 7-consecutive-day period. It allows an additional 2 hours of on-duty time (but not driving time) when the driver operates within 150 air-miles of the reporting location.",
  },
  {
    id: "gk225",
    question: "A driver who is required to take a 30-minute break must do so after how many hours of driving?",
    options: ["After 6 consecutive hours of driving", "After 7 consecutive hours of on-duty time", "After 8 consecutive hours of driving without a 30-minute break", "After 10 hours of driving"],
    answer: 2,
    explanation: "Property-carrying drivers must take a 30-minute break after 8 consecutive hours of driving. The break must be an off-duty or sleeper-berth period — on-duty non-driving time does not count.",
  },
  {
    id: "gk226",
    question: "The 'adverse driving conditions' exception allows a driver to extend driving time by how much?",
    options: ["1 hour", "2 hours", "3 hours", "4 hours"],
    answer: 1,
    explanation: "When a driver encounters adverse conditions (snow, ice, fog, accident) that were not foreseeable, the driver may drive up to 2 additional hours beyond the normal 11-hour driving limit.",
  },
  // ── MASSACHUSETTS SPECIFIC ────────────────────────────────────────────────────
  {
    id: "gk227",
    question: "In Massachusetts, a commercial vehicle permit is required when the gross vehicle weight exceeds:",
    options: ["73,280 pounds", "80,000 pounds", "90,000 pounds", "100,000 pounds"],
    answer: 1,
    explanation: "Massachusetts follows the federal standard: the maximum gross vehicle weight for interstate CMVs is 80,000 pounds. Loads exceeding this require a special permit from MassDOT.",
  },
  {
    id: "gk228",
    question: "Massachusetts law requires that Class B CDL holders operating a passenger vehicle (P endorsement) must pass a skills test in:",
    options: [
      "Any commercial vehicle",
      "A vehicle representative of the type they will drive — a passenger-carrying vehicle for the P endorsement",
      "A combination vehicle to demonstrate full CDL competency",
      "A Class A vehicle regardless of the endorsement sought",
    ],
    answer: 1,
    explanation: "To obtain a Passenger (P) endorsement in Massachusetts, the skills test must be taken in a passenger-carrying vehicle (e.g., a bus). You cannot take the test in a truck and receive the P endorsement.",
  },
  {
    id: "gk229",
    question: "In Massachusetts, a CDL holder with a BAC of 0.04% or higher while operating a CMV faces:",
    options: [
      "A written warning for a first offense",
      "A minimum one-year CDL disqualification for a first offense",
      "Loss of the hazmat endorsement only",
      "A 60-day suspension",
    ],
    answer: 1,
    explanation: "The federal and Massachusetts CDL standard for alcohol is 0.04% BAC while operating a CMV. A first offense results in at least a one-year disqualification. A second offense results in lifetime disqualification.",
  },
  {
    id: "gk230",
    question: "Under Massachusetts RMV rules, how long is a Commercial Learner's Permit (CLP) valid before it must be renewed or upgraded to a CDL?",
    options: ["3 months", "6 months", "1 year", "2 years"],
    answer: 2,
    explanation: "A CLP is valid for one year from the date of issue. The holder must pass the CDL skills test within that year, or the CLP must be renewed before taking the skills test.",
  },
  {
    id: "gk231",
    question: "A Massachusetts CDL holder must notify the RMV within how many days of a traffic conviction in another state?",
    options: ["10 days", "30 days", "60 days", "90 days"],
    answer: 1,
    explanation: "CDL drivers must report any out-of-state traffic conviction to their home state licensing authority within 30 days. Massachusetts requires this notification to update the driver's record.",
  },
  // ── PRE-TRIP INSPECTION — ADVANCED ───────────────────────────────────────────
  {
    id: "gk232",
    question: "When checking the fifth wheel during a pre-trip inspection on a combination vehicle, you should verify that:",
    options: [
      "The fifth wheel is greased with white lithium grease only",
      "The locking jaws are fully closed around the kingpin, the release arm is secure, and there is no excess play",
      "The fifth wheel is level with the ground",
      "The kingpin is bolted to the trailer frame",
    ],
    answer: 1,
    explanation: "Ensure the locking jaws are closed and locked around the kingpin, the release arm is in the locked position, and there are no cracks or wear in the fifth wheel plate. Excess play indicates a defect.",
  },
  {
    id: "gk233",
    question: "During a pre-trip inspection, what is the purpose of checking the brake adjustment?",
    options: [
      "To ensure the parking brake is applied",
      "To confirm that brakes apply evenly and within the specified stroke — out-of-adjustment brakes are a leading cause of brake failure",
      "To test the ABS warning light",
      "To verify the brake fluid level",
    ],
    answer: 1,
    explanation: "Brake adjustment affects stopping distance. An out-of-adjustment brake requires more chamber stroke to apply force, reducing braking effectiveness. This is a critical safety check.",
  },
  {
    id: "gk234",
    question: "What does it mean when you push on a tire during a pre-trip inspection and the tire feels soft?",
    options: [
      "The tire tread is worn and needs replacement",
      "The tire is under-inflated and must not be driven on until inflated to the correct pressure",
      "Soft tires are acceptable for city driving",
      "You should add air until the tire feels firm and continue the trip",
    ],
    answer: 1,
    explanation: "A soft tire is under-inflated. Under-inflation causes heat buildup, uneven wear, and can lead to a blowout. The tire must be inflated to the correct pressure before driving.",
  },
  // ── CARGO SECUREMENT — ADVANCED ──────────────────────────────────────────────
  {
    id: "gk235",
    question: "Under FMCSA cargo securement rules, how many tie-downs are required for cargo that is 5 feet or less in length and weighs 500 pounds or less?",
    options: ["No tie-downs are required", "At least one", "At least two", "At least three"],
    answer: 1,
    explanation: "Even short, lightweight cargo requires at least one tie-down. The general rule is that cargo must have at least one tie-down for every 10 feet of cargo length and at least two tie-downs for any cargo.",
  },
  {
    id: "gk236",
    question: "What is the minimum aggregate working load limit (WLL) for all tie-downs securing a load?",
    options: [
      "Equal to 25% of the cargo weight",
      "Equal to at least 50% of the cargo weight",
      "Equal to 75% of the cargo weight",
      "Equal to the full weight of the cargo",
    ],
    answer: 1,
    explanation: "The combined WLL of all tie-downs must be at least 50% of the weight of the cargo being secured. This ensures the cargo cannot shift forward, rearward, or laterally.",
  },
  // ── VEHICLE SYSTEMS — ADVANCED ────────────────────────────────────────────────
  {
    id: "gk237",
    question: "What is the purpose of the automatic traction control (ATC) system?",
    options: [
      "To prevent brake fade on steep grades",
      "To reduce drive-wheel spin on slippery surfaces by reducing engine power or applying brakes to spinning wheels",
      "To automatically adjust tire pressure in changing conditions",
      "To keep the vehicle in the correct lane using steering corrections",
    ],
    answer: 1,
    explanation: "ATC (also called traction control) senses drive-wheel spin and responds by reducing engine power or briefly applying the brake to the spinning wheel, transferring torque to wheels with better traction.",
  },
  {
    id: "gk238",
    question: "A dashboard warning light shaped like an engine is the:",
    options: [
      "Low coolant warning",
      "Check engine / malfunction indicator lamp (MIL) — indicates the engine management system has detected a fault",
      "Low oil pressure warning",
      "Transmission temperature warning",
    ],
    answer: 1,
    explanation: "The malfunction indicator lamp (MIL), commonly called 'check engine,' indicates that the onboard diagnostics system has detected a fault. The vehicle should be inspected by a mechanic before further operation.",
  },
  {
    id: "gk239",
    question: "What is engine braking (jake brake) and when should its use be limited?",
    options: [
      "Braking using the service brakes; limit use on icy roads",
      "Engine compression braking that slows the vehicle using the engine; some areas restrict its use in populated areas due to noise",
      "A system that automatically applies brakes when the engine overheats",
      "Downshifting to reduce speed; illegal in Massachusetts",
    ],
    answer: 1,
    explanation: "Engine braking (compression braking / 'jake brake') uses the engine's compression to slow the vehicle. Many municipalities restrict its use near residential areas due to the loud noise it produces.",
  },
  // ── ROADSIDE INSPECTIONS ──────────────────────────────────────────────────────
  {
    id: "gk240",
    question: "What is a Level I inspection in the CVSA North American Standard Inspection Program?",
    options: [
      "A quick check of only driver documents",
      "The most comprehensive inspection — a thorough examination of driver credentials, vehicle components, brakes, lights, cargo securement, and HOS records",
      "An annual inspection performed at an inspection station",
      "An inspection for vehicles hauling hazardous materials only",
    ],
    answer: 1,
    explanation: "A CVSA Level I (North American Standard) inspection is the most thorough roadside inspection. It covers the driver's credentials, HOS records, vehicle components (brakes, lights, tires, steering), and cargo securement.",
  },
  {
    id: "gk241",
    question: "If a vehicle is placed 'out of service' during a roadside inspection, the driver:",
    options: [
      "May drive to the nearest repair shop if it is within 10 miles",
      "Must not operate the vehicle until the out-of-service conditions are corrected",
      "May complete the current trip if carrying essential cargo",
      "May drive at reduced speed until reaching the destination",
    ],
    answer: 1,
    explanation: "An out-of-service order prohibits operation of the vehicle until the defects or violations are corrected. Operating a vehicle under an out-of-service order is a serious violation.",
  },
  // ── DISTRACTED DRIVING — UPDATED ─────────────────────────────────────────────
  {
    id: "gk242",
    question: "Federal regulations prohibit a CMV driver from texting while driving. 'Texting' is defined as:",
    options: [
      "Only sending SMS text messages",
      "Manually entering alphanumeric text into a device, sending or receiving messages of any kind (email, text, instant message), or viewing websites",
      "Texting with one hand while keeping the other on the wheel",
      "Texting only at speeds above 35 mph",
    ],
    answer: 1,
    explanation: "The federal definition of texting is broad — it includes any manual entry of text, email, instant messages, or web browsing. All such activities are prohibited while driving a CMV.",
  },
  {
    id: "gk243",
    question: "What is the maximum fine a CMV driver may face for using a hand-held mobile telephone while driving?",
    options: ["$1,000", "$2,750", "$5,000", "$11,000"],
    answer: 3,
    explanation: "FMCSA regulations impose civil penalties of up to $11,000 on drivers who use a hand-held mobile telephone while driving a CMV. Violations also count as serious traffic violations toward CDL disqualification.",
  },
  // ── MASSACHUSETTS BRIDGE & WEIGHT LAWS ───────────────────────────────────────
  {
    id: "gk244",
    question: "When approaching a posted bridge weight limit in Massachusetts, a driver must:",
    options: [
      "Slow down but may proceed if the posted limit is within 10% of the vehicle weight",
      "Not cross the bridge if the gross vehicle weight exceeds the posted limit",
      "Cross only if carrying a permit load",
      "Only comply with posted limits during wet weather",
    ],
    answer: 1,
    explanation: "Posted bridge weight limits are legal maximums — a driver must not cross if the vehicle's gross weight exceeds the posted limit. Doing so is illegal and can cause bridge damage or collapse.",
  },
  {
    id: "gk245",
    question: "In Massachusetts, what is the maximum single-axle weight allowed on public roads without a special permit?",
    options: ["18,000 pounds", "20,000 pounds", "22,400 pounds", "24,000 pounds"],
    answer: 2,
    explanation: "Massachusetts allows a maximum of 22,400 pounds per single axle (slightly above the federal 20,000-pound standard), subject to posted limits. Loads exceeding this require an oversize/overweight permit from MassDOT.",
  },
  // ── BRAKING TECHNIQUES ────────────────────────────────────────────────────────
  {
    id: "gk246",
    question: "Controlled braking is a technique used to:",
    options: ["Lock the front wheels to stop as quickly as possible", "Keep the vehicle in a straight line while braking firmly", "Apply maximum brake pressure to all wheels simultaneously", "Use only the engine brake to slow the vehicle"],
    answer: 1,
    explanation: "Controlled braking applies firm, steady brake pressure without locking the wheels, allowing the driver to maintain a straight line. It is used to stop in the shortest possible distance while keeping the vehicle under control.",
  },
  {
    id: "gk247",
    question: "To correct a drive-wheel braking skid, a driver should do all of the following, EXCEPT:",
    options: ["Remove your foot from the brake pedal", "Counter-steer after the vehicle returns to course", "Turn in the direction of the skid", "Accelerate to pull the wheels forward"],
    answer: 3,
    explanation: "To correct a drive-wheel braking skid: release the brake, steer into the direction of the skid, and counter-steer when the vehicle straightens. Accelerating would make the skid worse and must never be done.",
  },
  {
    id: "gk248",
    question: "During a vehicle inspection, checking which of the following will NOT help prevent a vehicle fire?",
    options: ["Cargo ventilation", "Electrical system insulation", "Battery fluid level", "Fuel system for leaks"],
    answer: 2,
    explanation: "CMV fires are typically caused by fuel leaks, faulty electrical systems, or hot exhaust contacting flammable material. Checking battery fluid level affects battery performance but does not directly help prevent vehicle fires.",
  },
  {
    id: "gk249",
    question: "To determine blood alcohol concentration (BAC) for a person, it is necessary to know:",
    options: ["How often the person drinks alcohol", "How much the person weighs", "How old the person is", "How long since the person last drank"],
    answer: 1,
    explanation: "BAC is calculated based on the amount of alcohol consumed, the person's body weight, and gender. Body weight directly affects how alcohol is distributed through the body — a lighter person will have a higher BAC from the same amount of alcohol.",
  },
  {
    id: "gk250",
    question: "The height of a vehicle's center of gravity:",
    options: ["Usually has no impact on how the vehicle handles", "Plays a large role in a driver's ability to safely handle the vehicle", "Is not a concern when loading the vehicle", "Only matters when driving on hills"],
    answer: 1,
    explanation: "A vehicle's center of gravity height significantly affects handling, especially during cornering and emergency maneuvers. Tall or top-heavy loads raise the center of gravity, making the vehicle much more prone to rollover.",
  },
  {
    id: "gk251",
    question: "Containerized loads are generally used when:",
    options: ["Freight is too heavy for regular trucks", "Freight is carried part of the way by rail or ship", "The cargo requires refrigeration", "Special tie-down equipment is not available"],
    answer: 1,
    explanation: "Containerized loads use standardized containers designed to transfer easily between trucks, railcars, and ships. They are used for intermodal shipments that travel by more than one mode of transportation.",
  },
  {
    id: "gk252",
    question: "If your truck or trailer catches fire, where should you park?",
    options: ["Near a fire station so help arrives quickly", "At a service station where a fire extinguisher is available", "Near other vehicles for safety in numbers", "In an open area, away from structures and other vehicles"],
    answer: 3,
    explanation: "Park in an open area away from structures, trees, and other vehicles to prevent the fire from spreading. Call 911 immediately and do not drive a burning vehicle into a building or populated area.",
  },
  {
    id: "gk253",
    question: "When being approached by a vehicle using bright headlights while driving at night, how can you avoid being blinded?",
    options: ["Put on sunglasses while driving at night", "Close your eyes briefly", "Glance toward the right edge of the road instead of looking directly at the headlights", "Turn on your high beams to signal the other driver"],
    answer: 2,
    explanation: "When oncoming headlights are blinding, look toward the right edge of the road. This prevents temporary blindness while still allowing you to see the road's edge and maintain your lane position.",
  },
  {
    id: "gk254",
    question: "How do you correct a rear wheel braking skid on ice or snow?",
    options: ["Apply more power to the wheels", "Stop accelerating and avoid braking or harsh steering inputs", "Steer sharply in the opposite direction of the skid", "Downshift immediately to a lower gear"],
    answer: 1,
    explanation: "On ice or snow, when the rear wheels begin to skid, stop accelerating and avoid any harsh steering or braking. Gentle, smooth inputs are essential on low-traction surfaces to regain control.",
  },
  {
    id: "gk255",
    question: "When driving on packed snow, you should reduce your speed:",
    options: ["By about one-quarter", "By about one-third", "By at least one-half", "By about one-eighth"],
    answer: 2,
    explanation: "On packed snow, traction is dramatically reduced. Reduce speed by at least half to maintain safe stopping distances and vehicle control. This applies even to vehicles with good snow tires.",
  },
  {
    id: "gk256",
    question: "Which of these may be a sign of tire failure while driving?",
    options: ["A loud hissing noise", "Gentle thumping or vibration from a wheel", "Wheels fishtailing", "A noticeable decrease in fuel efficiency"],
    answer: 1,
    explanation: "Gentle thumping or vibration from a wheel is a warning sign of tire problems — such as a developing blowout, flat spot, or tread separation. Pull over safely and inspect immediately. A loud bang typically means a blowout has already occurred.",
  },
  {
    id: "gk257",
    question: "What is 'counter-steering'?",
    options: ["Turning the steering wheel counterclockwise in any emergency", "Using steering axle brakes to prevent over-steering", "Turning the wheel back in the opposite direction after steering to avoid a traffic emergency", "Using both hands on the same side of the wheel for added leverage"],
    answer: 2,
    explanation: "Counter-steering is turning the wheel back the other way after you have steered to avoid a hazard. For example, if you steer right to avoid an obstacle, counter-steering means steering back left once clear to straighten the vehicle.",
  },
  {
    id: "gk258",
    question: "To avoid becoming too tired while driving, you should stop and take a break:",
    options: ["Every four hours or 200 miles", "Every two hours or 100 miles", "Every six hours or 300 miles", "Every eight hours as required by law"],
    answer: 1,
    explanation: "Fatigue experts recommend stopping every 2 hours or 100 miles for a short rest to stay alert. This is in addition to the regulatory 30-minute break required after 8 hours of driving.",
  },
  {
    id: "gk259",
    question: "When encountering fog while driving, you will be safest if you:",
    options: ["Stay in the left lane where visibility is slightly better", "Avoid driving in fog if at all possible", "Use your low beam lights and drive at a moderate speed", "Follow the vehicle ahead closely to use their taillights as a guide"],
    answer: 1,
    explanation: "The safest option in fog is to avoid driving in it altogether. If you must drive, use low beams, reduce speed significantly, increase following distance greatly, and never follow another vehicle closely.",
  },
  {
    id: "gk260",
    question: "Which of these is true about rear drive wheel braking skids?",
    options: ["Locked wheels always have more traction than rolling wheels", "On vehicles with trailers, the trailer can push the towing vehicle sideways", "Front wheels slide sideways trying to catch up with the rear wheels", "Increasing brake force helps correct a rear wheel skid"],
    answer: 1,
    explanation: "When the drive wheels of a tractor lock up, the trailer continues pushing forward, which can cause the tractor to swing sideways — a tractor jackknife. This is why preventing wheel lockup is critical when braking with a trailer.",
  },
  {
    id: "gk261",
    question: "Which of these is true regarding the use of drugs while driving a CMV?",
    options: ["Prescription drugs are allowed if a licensed medical practitioner certifies the drugs will not affect safe driving", "No prescription or non-prescription drugs are allowed at any time, for any reason", "Amphetamines like 'speed' are allowed to help the driver stay awake", "Over-the-counter cold medicines have no effect on CMV driving"],
    answer: 0,
    explanation: "A CMV driver may use a prescription drug while driving ONLY if a licensed medical practitioner has determined the drug will not adversely affect the driver's ability to safely operate a CMV. The driver must carry the prescription.",
  },
  {
    id: "gk262",
    question: "You do not have a HAZMAT endorsement on your CDL. You may still drive a vehicle transporting hazardous materials when:",
    options: ["The vehicle GVWR is 26,001 pounds or less", "The vehicle does not require placards for the hazmat being carried", "A person with a HAZMAT endorsement rides with you", "The hazmat shipment weighs less than 1,000 pounds"],
    answer: 1,
    explanation: "A HAZMAT endorsement is required only when transporting hazardous materials in quantities requiring placards. If the quantity is below the placard threshold, no endorsement is required.",
  },
  {
    id: "gk263",
    question: "When you need to stop in an emergency, you should:",
    options: ["Lock the wheels and skid to a stop as quickly as possible", "Stop in a way that keeps your vehicle in a straight line", "Steer sharply to the side of the road while braking", "Expect the vehicle to stop more quickly than normal"],
    answer: 1,
    explanation: "In an emergency stop, apply firm brake pressure while keeping the vehicle straight. Locking the wheels or steering sharply during heavy braking can cause loss of control or jackknife a trailer.",
  },
  {
    id: "gk264",
    question: "In mountain driving, which of these does NOT affect your choice of gears when driving on steep grades?",
    options: ["Weight of the load", "Tire tread type", "Steepness and length of the grade", "Current speed of the vehicle"],
    answer: 1,
    explanation: "Tire tread type does not affect what gear you should use on a grade. Gear selection for mountain driving depends on load weight, vehicle speed, and the steepness and length of the grade. Tire tread affects traction, not gear selection.",
  },
  {
    id: "gk265",
    question: "You are starting your vehicle from a stop and the drive wheels begin to spin as you apply power. You should:",
    options: ["Take your foot off the accelerator to let the wheels regain traction", "Apply the brakes while maintaining engine power to regain grip", "Shift to a lower gear to increase torque", "Accelerate quickly to push through the loss of traction"],
    answer: 0,
    explanation: "When drive wheels spin, there is insufficient traction. Release the accelerator to allow the wheels to slow and regain traction with the road. Continuing to accelerate will only worsen the wheel spin.",
  },
  {
    id: "gk266",
    question: "Where must hazardous materials placards be placed on a vehicle?",
    options: ["Only on the front of the vehicle", "On all four sides — front, rear, and both sides", "Only on the driver's side and rear", "Only on the sides of the vehicle"],
    answer: 1,
    explanation: "Federal regulations require hazmat placards on all four sides of the vehicle: front, rear, and both sides. This ensures the hazmat warning is visible to emergency responders from any direction.",
  },
  {
    id: "gk267",
    question: "When driving in cold weather, your tire tread should:",
    options: ["Be checked every 100 miles or every two hours", "Be double the minimum required depth", "Provide enough traction to steer and push the vehicle through snow", "Be slightly reduced to improve grip on ice"],
    answer: 2,
    explanation: "In cold weather, tires must have sufficient tread depth to maintain traction in snow and ice. The tread must be adequate to steer the vehicle and maintain forward momentum through packed snow conditions.",
  },
  {
    id: "gk268",
    question: "Merging onto a highway or road is safest when you:",
    options: ["Inch into the nearest lane so other vehicles give you room", "Gain speed on the shoulder then merge abruptly", "Wait for a gap in traffic that is large enough to enter safely", "Use your horn to alert traffic to your presence"],
    answer: 2,
    explanation: "The safest way to merge is to wait for a gap in traffic large enough to enter without forcing other vehicles to brake or change lanes. Matching the speed of traffic before merging also helps.",
  },
  // ── PASSENGER VEHICLE AWARENESS ──────────────────────────────────────────────
  {
    id: "gk269",
    question: "A stopped bus at a bus stop is:",
    options: ["Not a cause for concern if you don't see passengers", "Only a hazard if its hazard lights are on", "Not a roadway hazard if the bus is fully stopped", "Always a concern — whether or not passengers are visible"],
    answer: 3,
    explanation: "A stopped bus is always a hazard regardless of whether passengers are visible. Passengers may be crossing in front of or behind the bus, or approaching the door in ways not visible to other drivers.",
  },
  // ── FOLLOWING DISTANCE — EXPANDED ────────────────────────────────────────────
  {
    id: "gk270",
    question: "At speeds below 40 mph, what is the minimum following distance for a CMV?",
    options: ["1 second for every 10 feet of vehicle length", "2 seconds regardless of vehicle length", "3 seconds total regardless of speed", "Half a second per 10 feet of vehicle length"],
    answer: 0,
    explanation: "At speeds below 40 mph, allow 1 second for every 10 feet of vehicle length. At speeds above 40 mph, add 1 more second. A 60-foot truck needs at least 6 seconds below 40 mph and 7 seconds above 40 mph.",
  },
  // ── SPEED MANAGEMENT — EXPANDED ──────────────────────────────────────────────
  {
    id: "gk271",
    question: "When traveling down a downgrade, the speed of a vehicle will likely:",
    options: ["Decrease due to tire friction with the road", "Remain constant if you stay in the same gear", "Increase due to gravity pulling the vehicle downhill", "Only increase if the driver accelerates"],
    answer: 2,
    explanation: "Gravity pulls a vehicle downhill, causing speed to increase even without pressing the accelerator. Drivers must select the correct lower gear and use engine braking to maintain a safe, controlled speed.",
  },
  {
    id: "gk272",
    question: "You are driving a vehicle that could safely travel at 55 mph on an open road. Traffic is now heavy and moving at 35 mph in a 55 mph zone. The safest speed for your vehicle is most likely:",
    options: ["25 mph to stay well below other traffic", "45 mph to maintain a reasonable pace", "35 mph — matching the flow of traffic", "55 mph — the posted speed limit is the law"],
    answer: 2,
    explanation: "In heavy traffic, matching the speed of the traffic flow is safest. Traveling faster or slower than surrounding traffic significantly increases the risk of rear-end collisions and dangerous lane changes.",
  },
  // ── VISIBILITY ────────────────────────────────────────────────────────────────
  {
    id: "gk273",
    question: "When it is difficult to see because of dawn, dusk, or low light, the best way to make your vehicle more visible is:",
    options: ["Use your high beam headlights", "Turn on your low beam headlights", "Use only clearance or parking lights", "Avoid using lights — they can blind oncoming drivers"],
    answer: 1,
    explanation: "Turn on low beam headlights at dawn, dusk, and in any reduced-visibility conditions. Low beams make your vehicle visible to others while providing forward illumination without blinding oncoming drivers.",
  },
  {
    id: "gk274",
    question: "When passing another vehicle, pedestrian, or bicyclist, you should:",
    options: ["Make eye contact so they know you are passing", "Assume the person does not see you and give them plenty of space", "Honk your horn to alert them you are passing", "Wait for them to signal it is safe before passing"],
    answer: 1,
    explanation: "Never assume pedestrians, cyclists, or other road users can see your large vehicle. Act as if they cannot, give them maximum space when passing, and avoid sudden maneuvers. Honking near cyclists can startle them.",
  },
  {
    id: "gk275",
    question: "Convex (curved) mirrors on a CMV:",
    options: ["Make objects appear larger than they actually are", "Make objects appear closer than they actually are", "Show a wider viewing area but objects appear smaller and farther away than they really are", "Provide a more accurate distance estimate than flat mirrors"],
    answer: 2,
    explanation: "Convex mirrors show a wider field of view, reducing blind spots. However, objects appear smaller and farther away than they actually are. Drivers must account for this distortion when judging distances.",
  },
  {
    id: "gk276",
    question: "Which of the following can help you determine when to upshift?",
    options: ["Road speed only", "Engine speed (RPM) only", "Both road speed and engine speed", "Neither — always follow a preset gear schedule"],
    answer: 2,
    explanation: "Both road speed and engine RPM help determine when to upshift. Each gear has an optimal RPM range. Upshift when the engine reaches the top of its power range for the current gear, confirming road speed supports the higher gear.",
  },
  {
    id: "gk277",
    question: "When stopping a CMV, the brake pedal should be:",
    options: ["Pressed down gradually with steadily increasing pressure", "Pushed down quickly and firmly all at once", "Pumped repeatedly without holding it down continuously", "Always pressed with exactly the same force every stop"],
    answer: 0,
    explanation: "Smooth, gradual brake application prevents wheel lockup and allows for controlled, straight stops. Sudden, hard braking can cause loss of traction and, with a trailer, a potential jackknife.",
  },
  // ── PRE-TRIP INSPECTION — ADDITIONAL ─────────────────────────────────────────
  {
    id: "gk278",
    question: "When starting the engine as part of a pre-trip inspection, the driver should:",
    options: ["Rev the engine to warm it up quickly", "Listen for unusual noises that could indicate engine problems", "Turn up the radio to check the audio system", "Turn on the heater to test the climate control system"],
    answer: 1,
    explanation: "During the engine start portion of a pre-trip inspection, listen carefully for unusual knocking, rattling, or other abnormal sounds that could indicate mechanical problems requiring repair before the trip.",
  },
  {
    id: "gk279",
    question: "When doing a pre-trip inspection, you should ensure that the brake pads are:",
    options: ["Covered with a thin layer of grease for smooth operation", "Covered with coolant to prevent overheating", "Covered with oil to prevent squeaking", "Free of oil or grease contamination"],
    answer: 3,
    explanation: "Brake pads must be completely free of oil and grease. Contamination significantly reduces braking friction, creating a serious safety hazard. Any oil or grease on brake pads requires replacement of the pads.",
  },
  {
    id: "gk280",
    question: "After a tire has been changed, the driver should stop after a short distance to:",
    options: ["Check the tightness of the lug nuts", "Check the windshield wiper fluid level", "Inspect the wear pattern of the new tire", "Check the air pressure of all other tires"],
    answer: 0,
    explanation: "After changing a tire, lug nuts should be tightened to specification, but they can loosen slightly as the wheel seats. Always re-torque the lug nuts after driving a short distance to confirm they remain properly tight.",
  },
  // ── TURNING — ADVANCED ────────────────────────────────────────────────────────
  {
    id: "gk281",
    question: "You are driving a long vehicle and want to turn left from one two-lane street to another. When should you begin the turn?",
    options: ["As soon as you enter the intersection", "After moving to the left lane and confirming traffic is clear", "When you are about halfway through the intersection", "Only after your vehicle has come to a complete stop"],
    answer: 2,
    explanation: "With a long vehicle making a left turn, begin turning when you are about halfway through the intersection. Starting too early causes the rear of the vehicle to cut the corner or enter oncoming lanes. Starting at the midpoint allows proper tracking.",
  },
  {
    id: "gk282",
    question: "Which of these is NOT a proper use of vehicle lights?",
    options: ["Turning on headlights when visibility is reduced by rain or snow", "Flashing brake lights to warn a following driver you are slowing", "Flashing brake lights repeatedly to get a tailgating driver to back off", "Using four-way hazard flashers when stopped on the side of the road"],
    answer: 2,
    explanation: "Using brake lights to intimidate or express frustration to a tailgating driver is an improper and illegal use of lights in most states. Brake lights should only be used to communicate actual braking.",
  },
  {
    id: "gk283",
    question: "When should you check and adjust your mirrors?",
    options: ["While driving every few minutes", "Before starting a trip", "After completing a trip", "Mirrors rarely need adjustment"],
    answer: 1,
    explanation: "Always check and adjust your mirrors before starting a trip, while you are seated in the proper driving position. This ensures maximum visibility from the beginning. Check mirrors frequently while driving but never adjust them while moving.",
  },
  {
    id: "gk284",
    question: "The distance you should look ahead of your vehicle while driving at highway speeds is approximately:",
    options: ["One-eighth (1/8) of a mile", "One-quarter (1/4) of a mile", "One-half (1/2) of a mile", "One mile ahead"],
    answer: 1,
    explanation: "At highway speeds (55+ mph), look approximately 1/4 mile ahead — about 12 to 15 seconds of travel time. This gives you sufficient time to identify hazards and respond safely.",
  },
  {
    id: "gk285",
    question: "If you must drive in reverse, it is helpful to:",
    options: ["Back up as quickly as possible to minimize exposure time", "First exit the vehicle and walk the path to look for obstacles", "Use only the passenger side mirror for guidance", "Stick your head out the window and look backward"],
    answer: 1,
    explanation: "Before reversing, exit the vehicle and walk the intended path to identify any obstacles, low-hanging objects, or hazards you cannot see from the cab. If available, use a spotter to guide you throughout the maneuver.",
  },
  {
    id: "gk286",
    question: "After a vehicle is started, warning lights and buzzers should:",
    options: ["Stay on until the vehicle reaches full operating temperature", "Turn off within a few seconds as systems reach normal operating ranges", "Stay on until manually turned off", "Remain on throughout the trip as normal operation"],
    answer: 1,
    explanation: "Warning lights (oil pressure, battery, temperature, etc.) illuminate at startup as a self-test and should turn off within a few seconds once the engine starts and systems reach normal ranges. Lights that stay on indicate a problem requiring investigation.",
  },
  {
    id: "gk287",
    question: "If required to complete a vehicle inspection report in writing, when must the report be signed?",
    options: ["Every day regardless of whether defects were found", "Only if defects have been noted and certified to have been repaired or are not needed for safe operation", "Only if repairs are estimated to cost more than $1,000", "Only if requested by a law enforcement officer"],
    answer: 1,
    explanation: "A driver's vehicle inspection report requires signature only when defects have been reported. The carrier then certifies in writing that defects have been repaired or that repair is not necessary for safe operation.",
  },
  // ── CARGO AND LOADING — EXPANDED ─────────────────────────────────────────────
  {
    id: "gk288",
    question: "Which of these is true about your vehicle's overhead clearance?",
    options: ["The clearance height is fixed regardless of cargo weight", "The weight of cargo can change the height of your vehicle", "Low clearance warnings are always posted at every bridge and overpass", "Only the vehicle's unladen height matters for clearance"],
    answer: 1,
    explanation: "Heavy cargo compresses the suspension, which can lower the vehicle. Conversely, an empty trailer may sit higher than when loaded. Always know your current loaded height, especially when carrying unusual or heavy loads.",
  },
  {
    id: "gk289",
    question: "How does vehicle weight affect stopping distance?",
    options: ["Fully loaded trucks always stop in shorter distances than empty trucks", "Empty trucks can take longer to stop than loaded trucks because they have less traction on the drive axles", "Weight has no effect on stopping distance when brakes are properly adjusted", "Loaded and empty trucks stop in the same distance with equal brake pressure"],
    answer: 1,
    explanation: "An empty truck has less weight on its drive axles, resulting in less traction. With less traction, brakes can lock wheels more easily, reducing stopping effectiveness. This is why empty CMVs sometimes require more distance to stop than loaded ones.",
  },
  // ── VEHICLE SYSTEMS — ADDITIONAL ─────────────────────────────────────────────
  {
    id: "gk290",
    question: "When starting the vehicle during a pre-trip inspection, the coolant temperature gauge should:",
    options: ["Drop sharply as coolant circulates through the system", "Rise gradually to normal operating temperature", "Hold completely steady throughout the warm-up period", "Jump quickly to the normal operating range"],
    answer: 1,
    explanation: "The coolant temperature should rise gradually as the engine warms from cold start to normal operating temperature. A sudden spike, no movement, or failure to reach normal range all indicate potential cooling system problems.",
  },
  // ── TIRE SAFETY — EXPANDED ────────────────────────────────────────────────────
  {
    id: "gk291",
    question: "When checking tires during a pre-trip inspection, which of these statements is true?",
    options: ["Radial and bias-ply tires can be safely mixed on the same vehicle", "Tires of mismatched sizes should not be used on the same vehicle", "2/32 inch tread depth is acceptable for front steer tires", "Tires only need to be checked once a week"],
    answer: 1,
    explanation: "Mismatched tire sizes on the same axle cause uneven load distribution, handling problems, and excessive wear. Federal regulations prohibit mismatched tires on the same axle. Radial and bias-ply tires should not be mixed on the same axle.",
  },
  {
    id: "gk292",
    question: "Whenever you double your driving speed, your stopping distance increases by approximately:",
    options: ["Two times", "Three times", "Four times", "Eight times"],
    answer: 2,
    explanation: "Stopping distance increases with the square of speed. Double the speed = 2² = 4 times the stopping distance. For example, if you stop in 100 feet at 30 mph, at 60 mph it takes approximately 400 feet.",
  },
  {
    id: "gk303",
    question: "Where can you find the tire load rating?",
    options: ["On the inside of the driver's door", "On the vehicle dashboard", "Molded into the sidewall of each tire", "Under the vehicle hood"],
    answer: 2,
    explanation: "The load rating (maximum weight the tire can support), along with pressure rating and other specifications, is molded into the sidewall of each tire. Drivers should verify tires are rated for the vehicle's load.",
  },
  {
    id: "gk304",
    question: "Which of these is especially true about your tires in hot weather?",
    options: ["You should release some air to prevent over-pressure buildup", "If a tire is too hot to touch, hose it down with water to cool it", "Let out a small amount of air if the pressure seems high after driving", "You should check tire mounting and air pressure before driving"],
    answer: 3,
    explanation: "In hot weather, always check tire mounting and air pressure before driving. Never release air from hot tires — that leads to dangerous under-inflation. Never hose down hot tires — the sudden temperature change can damage the tire.",
  },
  // ── SPEED AND SIGNAGE ─────────────────────────────────────────────────────────
  {
    id: "gk305",
    question: "A sign indicating a maximum safe speed for a curve or ramp:",
    options: ["Is only a suggestion — vehicles may exceed it if conditions allow", "Applies only to vehicles weighing more than 26,000 pounds", "Should be strictly followed — no vehicle should travel faster than the posted speed", "Applies only to passenger automobiles, not commercial vehicles"],
    answer: 2,
    explanation: "Maximum safe speed signs (advisory speed signs) posted for curves and ramps indicate the fastest safe speed for that feature. CMV drivers should never exceed these speeds — and often need to go slower due to their higher center of gravity.",
  },
  // ── SEASONAL INSPECTION ───────────────────────────────────────────────────────
  {
    id: "gk306",
    question: "During a winter weather inspection, which vehicle system should receive extra attention?",
    options: ["Suspension system", "Steering system", "Exhaust system", "Windshield washer system"],
    answer: 2,
    explanation: "Cold temperatures can cause condensation and moisture in the exhaust system that may freeze and restrict exhaust flow. The exhaust system should be inspected in winter to ensure it is not blocked and that gases are properly expelled.",
  },
  // ── MOUNTAIN DRIVING — EXPANDED ──────────────────────────────────────────────
  {
    id: "gk307",
    question: "What should you do before driving through mountainous terrain?",
    options: ["Shift to a higher gear to build speed before steep grades", "Disconnect the engine brake to prevent wheel lockup on descents", "Know the locations of escape ramps on your planned route", "Carry tire chains regardless of the weather forecast"],
    answer: 2,
    explanation: "Before driving in mountains, know where runaway truck ramps are located on your route. If brakes fail on a steep downgrade, you must react immediately — there may not be time to search for a ramp.",
  },
  // ── TIRE FAILURE — EXPANDED ───────────────────────────────────────────────────
  {
    id: "gk308",
    question: "Which of these is NOT a characteristic of a front tire failure?",
    options: ["The steering wheel twisting or pulling to one side", "Difficulty steering the vehicle", "The vehicle fishtailing", "Vibration felt through the steering wheel"],
    answer: 2,
    explanation: "Vehicle fishtailing is characteristic of rear axle problems — such as trailer brake lockup or rear wheel traction loss — not a front tire failure. Front tire failures typically cause steering wheel pulling or vibration and make steering difficult.",
  },
  // ── EMERGENCIES — EXPANDED ────────────────────────────────────────────────────
  {
    id: "gk309",
    question: "If you need to leave the road in a traffic emergency to avoid a collision, you should:",
    options: ["Apply the brakes as hard as possible immediately", "Avoid braking until your speed has dropped to approximately 20 mph, then return to the road if safe", "Turn sharply back onto the road as soon as possible", "Avoid the shoulder because most shoulders cannot support a heavy vehicle"],
    answer: 1,
    explanation: "If you must leave the roadway in an emergency, avoid heavy braking until your speed drops to about 20 mph. Braking hard while steering off-road can cause loss of control. Once slowed, you can gently steer back onto the road when safe.",
  },
  // ── ABS ────────────────────────────────────────────────────────────────────────
  {
    id: "gk310",
    question: "A vehicle equipped with an Anti-Lock Braking System (ABS) can be identified by:",
    options: ["A sticker on the control panel", "A yellow ABS warning lamp on the instrument panel", "The letters 'ABS' printed on the brake pedal", "A metal plate on the inside of the driver's door"],
    answer: 1,
    explanation: "ABS-equipped vehicles have a yellow ABS warning indicator on the instrument panel that illuminates during the self-test at startup, then turns off. If it stays on or lights during driving, the ABS may not be functioning properly.",
  },
  // ── HAZARDOUS MATERIALS — EXPANDED ───────────────────────────────────────────
  {
    id: "gk311",
    question: "Which of these statements about labeling hazardous materials for shipping is true?",
    options: ["A four-inch circular red label must be placed on the outside of the container", "Gas cylinders that cannot hold a label must be shipped without any marking", "A four-inch, diamond-shaped hazardous materials label must be on the outside of each container", "Labels on individual packages are only required when the vehicle is also placarded"],
    answer: 2,
    explanation: "Individual hazmat packages must have a four-inch, diamond-shaped label identifying the hazard class. These are placed directly on the container — separate from vehicle placards which go on the outside of the vehicle.",
  },
  // ── CARGO INSPECTION ─────────────────────────────────────────────────────────
  {
    id: "gk312",
    question: "When inspecting cargo, the driver should do all of the following, EXCEPT:",
    options: ["Ensure the truck is not overloaded", "Ensure the cargo is balanced on the vehicle", "Ensure all cargo is properly secured", "Ensure breakable items are placed under heavier items"],
    answer: 3,
    explanation: "Fragile or breakable items must NEVER be placed under heavier items — they must be on top or separately secured to prevent crushing. Proper loading always places heavy items low and protects fragile items from heavy cargo above.",
  },
  {
    id: "gk313",
    question: "The total weight of a powered unit (tractor), the trailer, and all cargo combined is called the:",
    options: ["Gross Vehicle Weight (GVW)", "Gross Combination Weight (GCW)", "Gross Axle Weight Rating (GAWR)", "Net Cargo Weight (NCW)"],
    answer: 1,
    explanation: "The Gross Combination Weight (GCW) is the actual total weight of the tractor, trailer, and cargo. This is different from the Gross Combination Weight Rating (GCWR), which is the manufacturer's maximum rated capacity. GCW must not exceed GCWR.",
  },
  {
    id: "gk314",
    question: "Header boards on a commercial vehicle are used to:",
    options: ["Provide extra cargo storage above the cab area", "Protect the driver from being struck by cargo that shifts forward", "Protect the driver's head when entering or exiting the cab", "Provide additional mounting points for load straps"],
    answer: 1,
    explanation: "Header boards (also called headache racks) are installed behind the cab to protect the driver from cargo that shifts or falls forward during a sudden stop or collision.",
  },
  // ── RAILROAD CROSSINGS — EXPANDED ────────────────────────────────────────────
  {
    id: "gk315",
    question: "When approaching an active railroad crossing, which of these is true?",
    options: ["You will always be able to hear a train before it arrives", "You should expect to hear any approaching train", "You may not hear an approaching train due to cab noise, wind, and the train's aerodynamics", "Flashing lights will always activate before a train arrives"],
    answer: 2,
    explanation: "Never rely on hearing a train at a railroad crossing. Cab insulation, wind noise, audio systems, and the train's aerodynamics can all make it impossible to hear an approaching train. Always stop, look both ways, and listen before crossing.",
  },
  // ── COLLISION AVOIDANCE ───────────────────────────────────────────────────────
  {
    id: "gk316",
    question: "Which of these is a good technique when steering to avoid a crash?",
    options: ["Turn the wheel as far as possible to maximize your avoidance arc", "Avoid applying the brakes while steering", "Don't turn any more than necessary to clear the obstacle", "Accelerate while steering to increase vehicle stability"],
    answer: 2,
    explanation: "When steering to avoid a crash, turn only as much as needed to clear the obstacle. Over-steering at speed greatly increases the chance of a skid or rollover. Once past the hazard, counter-steer smoothly to straighten the vehicle.",
  },
  // ── WORK ZONES ────────────────────────────────────────────────────────────────
  {
    id: "gk293",
    question: "When driving through a work zone, you should watch especially for:",
    options: ["Only workers on foot near the road", "Only narrowed lanes and changed traffic patterns", "Sharp pavement drop-offs at the edges of the lanes", "Only signage indicating construction ahead"],
    answer: 2,
    explanation: "Work zones often have sharp vertical drops where old pavement was removed or lanes were shifted. Driving over a pavement edge drop-off at speed can cause a tire blowout or loss of control.",
  },
  // ── VEHICLE SYSTEMS — RETARDERS ───────────────────────────────────────────────
  {
    id: "gk294",
    question: "Which of these is NOT a type of retarder used on commercial vehicles?",
    options: ["Electric retarder", "Hydraulic retarder", "Robotic retarder", "Engine (compression release) retarder"],
    answer: 2,
    explanation: "The three types of retarders used on CMVs are engine (compression release), hydraulic (fluid coupling), and electric (electromagnetic). There is no such device as a 'robotic retarder.'",
  },
  // ── WIND AND WEATHER ─────────────────────────────────────────────────────────
  {
    id: "gk295",
    question: "Strong winds are most likely to suddenly affect your vehicle's handling when:",
    options: ["Driving on open flat highways", "Crossing bridges and overpasses", "Exiting tunnels", "Driving on mountain grades"],
    answer: 2,
    explanation: "When exiting a tunnel, a vehicle goes from a completely wind-sheltered environment to full exposure to crosswinds. This sudden change can push a large, high-profile vehicle off course, especially if unladen.",
  },
  // ── TURNING SAFETY ────────────────────────────────────────────────────────────
  {
    id: "gk296",
    question: "Which of the following is NOT a good way to reduce crashes when turning right with a large vehicle?",
    options: ["Turn slowly and carefully", "Keep the tail end close to the curb as you approach", "Keep an eye on oncoming traffic before turning", "Allow an open space on your right side as you approach the turn"],
    answer: 3,
    explanation: "Allowing open space on the right side as you approach a right turn invites other vehicles to pull up alongside on the right, where they will be hit when your vehicle swings wide. Keep right to prevent vehicles from pulling alongside.",
  },
  // ── DEFENSIVE DRIVING ────────────────────────────────────────────────────────
  {
    id: "gk297",
    question: "The best drivers are those who watch for and prepare for hazards before they occur. This approach is called being:",
    options: ["An offensive driver", "A defensive driver", "An objective driver", "A reactive driver"],
    answer: 1,
    explanation: "Defensive driving means identifying hazards early and taking action before problems develop. Defensive drivers constantly scan ahead, maintain safe following distances, and plan responses to unexpected situations.",
  },
  {
    id: "gk298",
    question: "If confronted by an aggressive or angry driver on the road, you should:",
    options: ["Make direct eye contact to assert your position", "React to their gestures and match their driving behavior", "Challenge them to establish who has the right of way", "Ignore the driver and avoid all engagement if possible"],
    answer: 3,
    explanation: "Never engage with aggressive drivers. Avoid eye contact, do not respond to gestures, and put as much distance between you and the aggressive driver as safely possible. If necessary, pull over safely and call authorities.",
  },
  {
    id: "gk299",
    question: "If you must cross into the oncoming lane as you make a turn, you should:",
    options: ["Speed up to complete the turn as quickly as possible", "Back up and approach the turn from a different angle", "Allow enough space to get your entire vehicle completely across the intersection before oncoming traffic arrives", "Stop in the intersection and wait for oncoming traffic to stop"],
    answer: 2,
    explanation: "When a turn requires swinging into the oncoming lane, you must have enough clear space to complete the entire turn — all wheels clearing the intersection — before any oncoming vehicles arrive. Never start a turn you cannot complete safely.",
  },
  // ── OVERHEAD CLEARANCE ────────────────────────────────────────────────────────
  {
    id: "gk300",
    question: "What should you do if you are unsure whether your vehicle has enough overhead clearance to safely pass under a bridge or obstacle?",
    options: ["Slow down and try to drive under carefully", "Stop and try to measure the obstacle height before proceeding", "Find another route that does not require driving under the uncertain obstacle", "Estimate the height and proceed if it looks close enough"],
    answer: 2,
    explanation: "If there is any doubt about whether your vehicle will fit under an overhead obstacle, take a different route. Guessing is never safe — striking an overhead structure can cause catastrophic damage to the vehicle, cargo, and the structure, and may cause serious injury.",
  },
  // ── ENGINE BRAKING ────────────────────────────────────────────────────────────
  {
    id: "gk301",
    question: "The engine braking effect is greatest when the engine is near the governed RPMs and the transmission is in:",
    options: ["The highest available gear", "A mid-range gear", "A lower gear", "Neutral"],
    answer: 2,
    explanation: "Engine braking is most effective when the engine is working near its governed (maximum) RPM range and the transmission is in a lower gear, creating the greatest resistance to slow the vehicle. Neutral disconnects the engine from the drive wheels, eliminating engine braking entirely.",
  },
  // ── SPECIAL CARGO ─────────────────────────────────────────────────────────────
  {
    id: "gk302",
    question: "Which of these statements about certain types of cargo is true?",
    options: ["Oversize loads may be transported without special permits during off-peak hours", "When liquids are transported, the tank should always be loaded completely full", "Unstable loads such as hanging meat or livestock can require extra caution on curves", "All cargo types are handled identically under federal CDL regulations"],
    answer: 2,
    explanation: "Unstable loads such as hanging meat or live animals shift their weight during turns and curves, affecting vehicle stability and handling. Drivers must reduce speed more than normal when taking curves with such loads.",
  },
  // ── MEDICAL CERTIFICATION — NRII ELECTRONIC SYSTEM (JUNE 2025) ───────────────
  {
    id: "gk317",
    question: "As of June 23, 2025, what is the official proof of a CDL driver's medical certification status?",
    options: [
      "The paper Medical Examiner's Certificate (MEC) card carried in the cab",
      "The driver's state Motor Vehicle Record (MVR), which is updated electronically by the medical examiner",
      "A letter from the certified medical examiner on file with the carrier",
      "The FMCSA National Registry website — drivers must print their own certification",
    ],
    answer: 1,
    explanation: "Under the FMCSA National Registry II (NRII) rule effective June 23, 2025, medical examiners transmit exam results electronically to FMCSA and the state licensing agency. The state MVR is now the official record of a driver's medical certification status — the paper MEC card is no longer the official proof.",
  },
  {
    id: "gk318",
    question: "Under the NRII electronic medical certification rule, what happens if a driver's certification does not appear on the state MVR within 48 hours of the medical exam?",
    options: [
      "The driver may continue operating using the paper MEC card indefinitely",
      "The driver should verify that all identifying information (name, CDL number, address) matches their CDL exactly, then contact the medical examiner and state licensing agency",
      "The driver must immediately stop operating a CMV and re-take the DOT physical",
      "FMCSA will contact the driver automatically — no action is needed",
    ],
    answer: 1,
    explanation: "Data mismatches (spelling, CDL number, address) are a common reason certifications fail to appear on the MVR. Drivers should confirm all information matches their CDL exactly. If the MVR still does not update, contact the medical examiner and state licensing agency to resolve the discrepancy.",
  },
  {
    id: "gk319",
    question: "Under Drug & Alcohol Clearinghouse Phase 2, employers must report CDL driver violations to the Clearinghouse within how many business days?",
    options: ["1 business day", "3 business days", "5 business days", "30 days"],
    answer: 1,
    explanation: "Clearinghouse Phase 2 requires employers to report alcohol test results at or above 0.04 BAC, test refusals, actual knowledge violations, and return-to-duty and follow-up testing results within 3 business days of the event.",
  },
  {
    id: "gk320",
    question: "Which of these is NOT a danger of rough acceleration? (2.2.1)",
    options: ["Tire damage", "Mechanical damage", "Damage to coupling"],
    answer: 1,
    explanation: "Rough acceleration can cause tire damage and loss of traction, but mechanical damage to the drivetrain is not a primary danger listed in the CDL manual for rough acceleration — jackknifing and cargo shift are the main concerns.",
  },
  {
    id: "gk321",
    question: "What is the proper way to hold the steering wheel? (2.2.2)",
    options: [
      "With both hands close together, near the top of the wheel",
      "With both hands close together, near the bottom of the wheel",
      "With both hands, on opposite sides of the wheel",
    ],
    answer: 2,
    explanation: "Hold the steering wheel with both hands on opposite sides (approximately 9 o'clock and 3 o'clock positions). This gives maximum control, especially during a blowout or emergency.",
  },
  {
    id: "gk322",
    question: "You should use your mirrors to check: (2.4.2)",
    options: [
      "If your running lights are working properly",
      "Blind spots only",
      "Where the rear of your vehicle is while you make turns",
    ],
    answer: 2,
    explanation: "Mirrors must be used to monitor the rear of the vehicle during turns and lane changes. For large vehicles that off-track, watching the rear wheels helps prevent running over curbs or other vehicles.",
  },
  {
    id: "gk323",
    question: "CDL medical certificates must be renewed every: (section 1)",
    options: ["Year", "Two years", "Four years"],
    answer: 1,
    explanation: "DOT medical certificates for CDL holders are valid for up to two years. Drivers with certain medical conditions may need more frequent recertification.",
  },
  {
    id: "gk324",
    question: "How far should a driver look ahead of the vehicle while driving? (2.4.1)",
    options: ["1-2 seconds", "5-8 seconds", "12-15 seconds"],
    answer: 2,
    explanation: "Drivers should look at least 12-15 seconds ahead (about a quarter mile at highway speeds) to identify hazards early and have time to react safely.",
  },
  {
    id: "gk325",
    question: "How many missing or broken leaves in any leaf spring will cause a commercial vehicle to be placed out of service? (2.1.3)",
    options: ["One-fourth of the total number", "One-third of the total number", "One-half of the total number"],
    answer: 0,
    explanation: "A vehicle will be placed out of service if one-fourth or more of the leaf springs in any spring assembly are broken or missing.",
  },
  {
    id: "gk326",
    question: "Which of these statements about backing a heavy vehicle is not true? (2.2.4)",
    options: [
      "You should back and turn toward the driver's side whenever possible",
      "You should back quickly until you slightly bump the dock so you know you are close enough",
      "Because you cannot see well, you should use a helper when backing",
    ],
    answer: 1,
    explanation: "You should NEVER back quickly and bump the dock. Always back slowly, use mirrors, and use a helper when available. Backing toward the driver's side is recommended because you have better visibility.",
  },
  {
    id: "gk327",
    question: "Which of these statements about double clutching and shifting is true? (2.3.1)",
    options: [
      "Double clutching should not be used when the road is slippery",
      "Double clutching should only be used with buses",
      "You can use the tachometer to tell you when to shift",
    ],
    answer: 2,
    explanation: "The tachometer shows engine RPM and is the best guide for when to shift up or down. Double clutching is appropriate for most commercial vehicles and can be especially useful on slippery roads.",
  },
  {
    id: "gk328",
    question: "In your mirror, you see a car approaching from the rear. The next time you check your mirror, you do not see the car. You should: (2.4.2)",
    options: [
      "Wait to change lanes until you are sure the car isn't in your blind spot",
      "Ease into the other lane so the car can get out of the way if it is beside you",
      "Assume the car left the road and change lanes as normal",
    ],
    answer: 0,
    explanation: "If a car disappears from your mirror, it has likely moved into your blind spot beside you. Never change lanes until you are certain no vehicle is there.",
  },
  {
    id: "gk329",
    question: "The distance you should look ahead of your vehicle while driving amounts to about ___ mile at highway speeds: (2.4.1)",
    options: ["1/8", "1/4", "1/2"],
    answer: 1,
    explanation: "At highway speeds, looking 12-15 seconds ahead translates to approximately 1/4 mile. This gives you time to identify and respond to hazards.",
  },
  {
    id: "gk330",
    question: "Merging onto a road is safest if you: (2.17.1)",
    options: [
      "Inch over into the nearest lane so that other vehicles will give you room",
      "Gain speed on the shoulder and then merge",
      "Wait for a large enough gap in traffic to enter the road",
    ],
    answer: 2,
    explanation: "Always wait for a gap large enough to safely enter traffic. Never force other drivers to brake or swerve to accommodate your merge.",
  },
  {
    id: "gk331",
    question: "What is the term for a commercial vehicle's habit of swinging wide on turns? (2.7.6)",
    options: ["Off-tracking", "Wide-rounding", "Sidewinding"],
    answer: 1,
    explanation: "Wide-rounding is when the front of the vehicle swings wide into adjacent lanes while turning. This is different from off-tracking (when rear wheels cut inside the front wheels' path).",
  },
  {
    id: "gk332",
    question: "You can see a marking on the vehicle ahead of you. The marking is a red triangle with an orange center. What does the marking mean? (2.8.3)",
    options: [
      "It may be a slow-moving vehicle",
      "The vehicle is transporting hazardous materials",
      "It is being driven by a student driver",
    ],
    answer: 0,
    explanation: "A red triangle with an orange reflective center (the Slow Moving Vehicle emblem) identifies vehicles that travel at speeds of 25 mph or less, such as farm equipment or horse-drawn vehicles.",
  },
  {
    id: "gk333",
    question: "What should you do if a car coming toward you at night keeps its high beams on? (2.11.5)",
    options: [
      "Flash your high beams quickly at the other driver",
      "Look to the right lane or edge marking of the road",
      "Slow down and look straight ahead in your lane",
    ],
    answer: 1,
    explanation: "If oncoming high beams blind you, look toward the right edge of the road or lane marking. This keeps you on course without looking directly into the blinding lights.",
  },
  {
    id: "gk334",
    question: "Whenever you double your speed, your vehicle has about ___ times the destructive power if it crashes: (2.6.1)",
    options: ["Two", "Three", "Four"],
    answer: 2,
    explanation: "Kinetic energy increases with the square of speed. Doubling your speed quadruples the destructive force in a crash, which is why speed management is critical for CMV drivers.",
  },
  {
    id: "gk335",
    question: "When you are passing another vehicle, pedestrian, or bicyclist, you should assume that they: (2.5.2)",
    options: [
      "May move into your traffic lane",
      "Know you want to pass",
      "See your vehicle",
    ],
    answer: 0,
    explanation: "Always assume that pedestrians, cyclists, and other drivers may move into your path unexpectedly. Give them plenty of space and be prepared to react.",
  },
  {
    id: "gk336",
    question: "Placards must be: (2.23.3)",
    options: [
      "Displayed on all vehicles transporting any amount of hazardous materials",
      "Placed only on the front and rear of a vehicle",
      "Placed on all four sides of a vehicle",
    ],
    answer: 2,
    explanation: "Hazardous materials placards must be placed on all four sides of the vehicle — front, rear, and both sides — so they are visible from any direction.",
  },
  {
    id: "gk337",
    question: "Which of these statements about seeing ahead is true? (2.4.1)",
    options: [
      "Good drivers shift their attention back and forth, near and far",
      "Good drivers keep their attention on one place for 12-15 seconds at a time",
      "At highway speeds, you should look 3-5 seconds ahead of you",
    ],
    answer: 0,
    explanation: "Good drivers continuously scan — shifting their eyes near and far, left and right — rather than staring at one point. This allows earlier hazard detection.",
  },
  {
    id: "gk338",
    question: "Which of these is not a good rule to follow when caring for injured at an accident scene? (2.20.3)",
    options: [
      "If a qualified person is helping them, stay out of the way unless asked to assist",
      "Move severely injured persons if there is a danger due to fire or passing traffic",
      "Keep injured person cool",
    ],
    answer: 2,
    explanation: "Keeping an injured person cool is NOT a general rule for accident scene care. You should keep injured people warm and still unless there is immediate danger from fire or traffic.",
  },
  {
    id: "gk339",
    question: "What should you do before driving in mountains? (2.17.3)",
    options: [
      "Know the escape ramp locations on your route",
      "Unhook your steering axle brakes",
      "Carry tire chains in your vehicle",
    ],
    answer: 0,
    explanation: "Before driving in mountain terrain, identify where escape ramps are located on your route. If your brakes fail on a downgrade, knowing ramp locations in advance can save lives.",
  },
  {
    id: "gk340",
    question: "You are driving a heavy vehicle. You must exit a highway using an off ramp that curves downhill. You should: (2.6.3)",
    options: [
      "Slow down to a safe speed before the curve",
      "Slow to the posted speed limit for the off-ramp",
      "Wait until you are in the curve before downshifting",
    ],
    answer: 0,
    explanation: "Always slow to a safe speed BEFORE entering a curve on a downhill off-ramp. The posted speed limit applies to cars — heavy vehicles need to go slower due to higher center of gravity and braking distances.",
  },
  {
    id: "gk341",
    question: "Which of these is a good thing to do when driving at night? (2.11.3)",
    options: [
      "Keep your speed slow enough that you can stop within the range of your headlights",
      "Look directly at oncoming headlights only briefly",
      "Keep your instrument lights bright",
    ],
    answer: 0,
    explanation: "Drive at a speed where you can stop within the distance your headlights illuminate. Overdriving your headlights (going too fast to stop in time) is a major nighttime hazard.",
  },
  {
    id: "gk342",
    question: "When you are parked at the side of the road at night, you must: (2.5.2)",
    options: [
      "Put out your emergency warning devices within 30 minutes",
      "Use your taillights to give warning to other drivers",
      "Turn on your 4-way emergency flashers to warn others",
    ],
    answer: 2,
    explanation: "When stopped on the roadside at night, immediately turn on your 4-way hazard flashers and place emergency warning devices (triangles/flares) within 10 minutes.",
  },
  {
    id: "gk343",
    question: "'Implied consent' means: (1.3.2)",
    options: [
      "It is understood that you may drink alcohol now and then",
      "You have given your consent to be tested for alcohol in your blood",
      "You have given your consent to inspection of your vehicle for alcohol",
    ],
    answer: 1,
    explanation: "Implied consent means that by holding a CDL and operating a commercial vehicle, you have already consented to alcohol and drug testing when lawfully requested.",
  },
  {
    id: "gk344",
    question: "For a first offense of driving a commercial vehicle under the influence of alcohol or drugs, you will lose your CDL for at least: (Pg. 1-22)",
    options: ["6 months", "2 years", "1 year"],
    answer: 2,
    explanation: "A first DUI/DWI offense while operating a CMV results in a mandatory CDL disqualification of at least 1 year (3 years if hauling hazardous materials).",
  },
  {
    id: "gk345",
    question: "You are checking your tires for a pre-trip inspection. Which of these statements is true? (11.3.4)",
    options: [
      "Tires of mismatched sizes should not be used on the same vehicle",
      "Radial and bias-ply tires can be used together on the same vehicle",
      "2/32 inch tread depth is safe for the front tires",
    ],
    answer: 0,
    explanation: "Mismatched tire sizes on the same axle are prohibited and unsafe. Minimum tread depth for front tires is 4/32 inch, and 2/32 inch for other tires.",
  },
  {
    id: "gk346",
    question: "Optional safety equipment may include emergency phone numbers, tire chains, and: (11.2.2)",
    options: [
      "Tire changing equipment",
      "Red reflective triangles",
      "Charged fire extinguisher",
    ],
    answer: 2,
    explanation: "Tire chains and a charged fire extinguisher are examples of optional (recommended but not always required) safety equipment, while red reflective triangles and certain fire extinguishers are required.",
  },
  {
    id: "gk347",
    question: "Which of these is true regarding the use of drugs while driving? (2.22.2)",
    options: [
      "Prescription drugs are allowed if a doctor says the drugs will not affect safe driving",
      "No prescription or non-prescription drugs are allowed at any time, for any reason",
      "Use of amphetamines like 'speed' is allowed if you are using the drugs to stay awake",
    ],
    answer: 0,
    explanation: "Prescription drugs are allowed only if a licensed doctor has prescribed them and certifies they will not impair safe driving. All illegal drugs and misused prescription drugs are prohibited.",
  },
  {
    id: "gk348",
    question: "A full stop is required at a railroad grade crossing when: (2.15.4)",
    options: [
      "The crossing is located in a city or town with frequent train traffic",
      "There are no flagmen, warning signals, or gates at the crossing",
      "The nature of the cargo makes a stop mandatory under state or federal regulations",
    ],
    answer: 2,
    explanation: "Certain cargo types (such as hazardous materials requiring placards, or vehicles carrying passengers) require a full stop at all railroad crossings regardless of signal presence.",
  },
  {
    id: "gk349",
    question: "You should try to park so that: (2.2.4)",
    options: [
      "You can pull forward when you leave",
      "There is at least one curb next to your vehicle",
      "Your vehicle is protected by trees or some other overhang",
    ],
    answer: 0,
    explanation: "Whenever possible, park so you can pull forward when leaving. Backing out is more dangerous because you have limited visibility of traffic and pedestrians.",
  },
  {
    id: "gk350",
    question: "Truck escape ramps: (2.17.3)",
    options: [
      "Help avoid damage to vehicles",
      "Cannot be used by certain types of heavy vehicles",
      "Are not for buses",
    ],
    answer: 0,
    explanation: "Truck escape ramps are designed to safely stop runaway vehicles. While they may cause some vehicle damage, they prevent far worse outcomes. Any heavy vehicle with brake failure should use them.",
  },
  {
    id: "gk351",
    question: "You are starting your vehicle in motion from a stop. As you apply power, the drive wheels start to spin. You should: (2.19)",
    options: [
      "Take your foot off the accelerator",
      "Take your foot off the accelerator and apply the brakes",
      "Try to lower the gear",
    ],
    answer: 0,
    explanation: "If drive wheels spin when starting from a stop, ease off the accelerator immediately to reduce wheel spin and restore traction. Applying brakes while spinning can cause skidding.",
  },
  {
    id: "gk352",
    question: "Which of these statements about shipping hazardous materials is true? (2.23.3)",
    options: [
      "A four-inch, circular, red hazardous materials label must be on the container",
      "A four-inch, circular, red hazardous materials label must be shipped under cover",
      "A four-inch, diamond-shaped hazardous materials label must be on the container",
    ],
    answer: 2,
    explanation: "Hazardous materials labels are four-inch, diamond-shaped (not circular) and must be affixed to the container. The diamond shape is a key identifying feature of hazmat labels.",
  },
];

export default generalKnowledge;
